import * as React from "react";
import DrawSVG from "react-svg-drawing";
import "./UnoBot.css";

const UnoBot = (props) => (
  <DrawSVG width="100%" stroke="transparent">
      <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 650 531.44"
    {...props}
  >
    <defs>
      <radialGradient
        id="Degradado_sin_nombre_30"
        data-name="Degradado sin nombre 30"
        cx={711.55}
        cy={542.4}
        r={28.61}
        gradientTransform="matrix(-0.76, 0.65, -0.65, -0.76, 1195.05, 341.13)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#fff" />
        <stop offset={0.16} stopColor="#f7f9fa" />
        <stop offset={0.43} stopColor="#e0eaec" />
        <stop offset={0.75} stopColor="#bad0d6" />
        <stop offset={1} stopColor="#99b9c2" />
      </radialGradient>
      <radialGradient
        id="Degradado_sin_nombre_79"
        data-name="Degradado sin nombre 79"
        cx={-637.4}
        cy={-6657.82}
        r={79.71}
        gradientTransform="matrix(1, 0.02, 0.02, -1, 1130.46, -6255.53)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#fff" />
        <stop offset={0.25} stopColor="#fcfdfd" />
        <stop offset={0.44} stopColor="#f2f6f8" />
        <stop offset={0.61} stopColor="#e2ebee" />
        <stop offset={0.77} stopColor="#ccdce0" />
        <stop offset={0.91} stopColor="#aec8cf" />
        <stop offset={1} stopColor="#99b9c2" />
      </radialGradient>
      <clipPath id="clip-path">
        <ellipse
          className="clss-1"
          cx={394.58}
          cy={400.99}
          rx={6.46}
          ry={38.23}
          transform="translate(-13.81 787.9) rotate(-88.92)"
        />
      </clipPath>
      <clipPath id="clip-path-2">
        <path
          className="clss-1"
          d="M432.78,401.89c-1.28,3.41-16.56,6-38.32,5.55-20.63-.46-38.27-3.34-38.12-7.39h0a108.66,108.66,0,0,0-3.52,22.66c0,1.14,0,2.26.08,3.38,1.37,20.5,18.82,37.1,40.45,37.45,22.81.38,41.69-17,42-39.21C435.51,418.76,434.66,411.15,432.78,401.89Z"
        />
      </clipPath>
      <linearGradient
        id="Degradado_sin_nombre_3"
        data-name="Degradado sin nombre 3"
        x1={11658.27}
        y1={481.15}
        x2={11636.41}
        y2={631.19}
        gradientTransform="matrix(0.99, -0.13, 0.11, 0.99, -11296.26, 1271.23)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#010159" />
        <stop offset={0.46} stopColor="#010154" />
        <stop offset={0.99} stopColor="#010146" />
        <stop offset={1} stopColor="#010146" />
      </linearGradient>
      <radialGradient
        id="Degradado_sin_nombre_5"
        data-name="Degradado sin nombre 5"
        cx={16539.8223}
        cy={-2235.4448}
        r={110.0076}
        gradientTransform="matrix(1 0 -2.350213e-05 1 -16174.8447 2543.7188)"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset={0}
          style={{
            stopColor: "#FFFFFF",
          }}
        />
        <stop
          offset={0.1633}
          style={{
            stopColor: "#F8FAFB",
          }}
        />
        <stop
          offset={0.4055}
          style={{
            stopColor: "#E4ECEF",
          }}
        />
        <stop
          offset={0.6968}
          style={{
            stopColor: "#C3D6DB",
          }}
        />
        <stop
          offset={1}
          style={{
            stopColor: "#99B9C2",
          }}
        />
      </radialGradient>
      <clipPath id="clip-path-3">
        <path
          className="clss-1"
          d="M470.31,295.54c-13.83-27.48-42.1-41.61-74.76-41.49s-60.19,15-74.51,42.11c-4.08,7.86-1.34,13.65-1.21,35.34s-2.8,29.36,3.78,38.14c14.56,18.7,41.43,26.19,72.44,26,30.83-.12,57.88-7.92,72.26-26.93C481.4,348.91,477.14,311.74,470.31,295.54Z"
        />
      </clipPath>
      <linearGradient
        id="Degradado_sin_nombre_3-2"
        x1={483.61}
        y1={232.69}
        x2={456.73}
        y2={381.09}
        gradientTransform="translate(-72.13 139.29) rotate(-17.34)"
        xlinkHref="#Degradado_sin_nombre_3"
      />
      <radialGradient
        id="Degradado_sin_nombre_29"
        data-name="Degradado sin nombre 29"
        cx={171.27}
        cy={403.2}
        r={74.77}
        gradientTransform="matrix(0.84, 0.01, -0.01, 0.95, 179.24, -97.19)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#99b9c2" />
        <stop offset={0.17} stopColor="#849fb3" />
        <stop offset={0.53} stopColor="#4d5e8e" />
        <stop offset={1} stopColor="#010159" />
      </radialGradient>
      <clipPath id="clip-path-4">
        <path
          className="clss-1"
          d="M407.1,374.31c-22.61,10.17-52.21,10.23-74-1.15-5.89-3.07-9.65-10.09-9.55-17.78l.45-36.07c.05-4,2.41-7.54,5.7-8.43A146.59,146.59,0,0,1,412,312.14c3.27,1,5.53,4.56,5.48,8.6L417,356.85C417,364.51,413.11,371.61,407.1,374.31Z"
        />
      </clipPath>
      <linearGradient
        id="Degradado_sin_nombre_28"
        data-name="Degradado sin nombre 28"
        x1={-842.84}
        y1={371.94}
        x2={-776.43}
        y2={371.94}
        gradientTransform="matrix(-1, 0, 0.27, 1, -583.36, 0)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#23185a" />
        <stop offset={1} stopColor="#3b2185" />
      </linearGradient>
      <linearGradient
        id="Degradado_sin_nombre_28-2"
        x1={-968.93}
        y1={351.83}
        x2={-879.51}
        y2={351.83}
        gradientTransform="matrix(-1, 0, 0.21, 1, -572.17, 0)"
        xlinkHref="#Degradado_sin_nombre_28"
      />
      <linearGradient
        id="Degradado_sin_nombre_3-3"
        x1={11809.81}
        y1={427.31}
        x2={11780.83}
        y2={587.32}
        gradientTransform="matrix(0.99, -0.15, 0.12, 0.99, -11291.92, 1510.83)"
        xlinkHref="#Degradado_sin_nombre_3"
      />
      <radialGradient
        id="Degradado_sin_nombre_2"
        data-name="Degradado sin nombre 2"
        cx={468.73}
        cy={124.04}
        r={36.3}
        gradientTransform="matrix(0.5, -0.87, 0.87, 0.5, 102.62, 796.22)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#fff" />
        <stop offset={0.16} stopColor="#f7f9fa" />
        <stop offset={0.41} stopColor="#e0eaec" />
        <stop offset={0.72} stopColor="#bad0d6" />
        <stop offset={0.95} stopColor="#99b9c2" />
      </radialGradient>
      <linearGradient
        id="Degradado_sin_nombre_28-3"
        x1={-1063.03}
        y1={391.95}
        x2={-973.61}
        y2={391.95}
        gradientTransform="matrix(-1, 0, 0.21, 1, -572.17, 0)"
        xlinkHref="#Degradado_sin_nombre_28"
      />
      <linearGradient
        id="Degradado_sin_nombre_28-4"
        x1={-628.81}
        y1={394.53}
        x2={-562.41}
        y2={394.53}
        xlinkHref="#Degradado_sin_nombre_28"
      />
    </defs>
    <g className="clss-2">
      <g id="uno">
        <rect
          id="unobotCavasBg"
          className="clss-3"
          width={650}
          height={531.44}
        />
        <ellipse
          id="bodyShadow"
          className="clss-4"
          cx={394.58}
          cy={491.04}
          rx={28.33}
          ry={2.82}
        />
        <g id="leftHandGroup">
          <g id="leftHandThumb">
            <path
              className="clss-5"
              d="M309.7,379.47c-5.58-1.71-9-7.18-9.95-12.69-1-4.77,6-6.35,7.2-1.63a3.84,3.84,0,0,1,.09,1c-.23,3.53,1,7.38,4,9.4l.75,1.26a1.83,1.83,0,0,1-2.1,2.65Z"
            />
            <g>
              <path
                className="clss-5"
                d="M304.11,370.89c1.68-1.29,3.34-2,4.69-.25l1.88,2.44a3.82,3.82,0,0,1-.75,5.64,3.91,3.91,0,0,1-5.63-.75l-1.87-2.43C301.08,373.77,302.15,372.4,304.11,370.89Z"
              />
              <path
                className="clss-6"
                d="M305.28,372.74c1.68-1.21,2.17-3.86,3.52-2.1l1.88,2.44a3.82,3.82,0,0,1-.75,5.64,3.91,3.91,0,0,1-5.63-.75l-1.87-2.43C301.08,373.77,303.27,374.18,305.28,372.74Z"
              />
            </g>
          </g>
          <g id="leftHand">
            <path
              id="palm"
              className="clss-7"
              d="M321.21,379.66a18.94,18.94,0,0,0-21.84,30.94c8.55,6,28,9.4,34,.85S329.75,385.69,321.21,379.66Z"
            />
            <g id="leftHandOpenedFingers">
              <g>
                <path
                  className="clss-5"
                  d="M293.11,402.43a23.67,23.67,0,0,1-8.89-.82,3,3,0,0,1,1.89-5.65,2.82,2.82,0,0,1,1,.53c1.6,1.24,4.33,2.08,6.4,2.68a1.67,1.67,0,0,1-.36,3.26Z"
                />
                <g>
                  <path
                    className="clss-5"
                    d="M286.14,399.7c-.32,1.64-.22,3.06,1.49,3.38l2.38.45A3,3,0,0,0,293.7,401a3.07,3.07,0,0,0-2.53-3.68l-2.37-.45C287.08,396.55,286.5,397.79,286.14,399.7Z"
                  />
                  <path
                    className="clss-6"
                    d="M287.85,399.87c-.25,1.61-1.93,2.89-.22,3.21l2.38.45A3,3,0,0,0,293.7,401a3.07,3.07,0,0,0-2.53-3.68l-2.37-.45C287.08,396.55,288.15,397.94,287.85,399.87Z"
                  />
                </g>
              </g>
              <g>
                <path
                  className="clss-5"
                  d="M293.76,392.37a4.28,4.28,0,0,1-1.41.14c-4-.34-7.23-3-10.14-5.35a3.42,3.42,0,1,1,4.4-5.24c1.29,1.38,2.2,3.13,3.54,4.46a10.27,10.27,0,0,0,2.8,2.2s-.05,0-.21.09a1.92,1.92,0,0,1,1,3.7Z"
                />
                <g>
                  <path
                    className="clss-5"
                    d="M286.28,387c-1,1.62-1.57,3.19.13,4.28l2.36,1.51a3.47,3.47,0,0,0,5.06-1.1,3.56,3.56,0,0,0-1.1-5.06l-2.36-1.51C288.67,384,287.5,385.05,286.28,387Z"
                  />
                  <path
                    className="clss-6"
                    d="M288,387.87c-1,1.62-3.33,2.27-1.63,3.36l2.36,1.51a3.47,3.47,0,0,0,5.06-1.1,3.56,3.56,0,0,0-1.1-5.06l-2.36-1.51C288.67,384,289.2,385.94,288,387.87Z"
                  />
                </g>
              </g>
              <g>
                <path
                  className="clss-5"
                  d="M296.15,384.48a30.51,30.51,0,0,1-8.49-9.37,3.42,3.42,0,1,1,6.34-2.44,26.1,26.1,0,0,0,4.84,9.1,1.93,1.93,0,0,1-2.69,2.71Z"
                />
                <g>
                  <path
                    className="clss-5"
                    d="M292.22,376.85c-1.58,1.1-2.66,2.36-1.5,4l1.61,2.3a3.47,3.47,0,0,0,5.1.9,3.57,3.57,0,0,0,.9-5.11l-1.61-2.29C295.56,375,294.07,375.56,292.22,376.85Z"
                  />
                  <path
                    className="clss-6"
                    d="M293.51,378.37c-1.52,1.14-3.95.84-2.79,2.49l1.61,2.3a3.47,3.47,0,0,0,5.1.9,3.57,3.57,0,0,0,.9-5.11l-1.61-2.29C295.56,375,295.31,377,293.51,378.37Z"
                  />
                </g>
              </g>
              <g>
                <path
                  className="clss-5"
                  d="M316.87,381.28a7.44,7.44,0,0,0-3-5.51A9.92,9.92,0,0,0,312,374.7a3.42,3.42,0,0,1,2.95-6.17,12.66,12.66,0,0,1,3.31,3.1,12.42,12.42,0,0,1,2.63,8.49c-.09,1.48-.4,3.55-2.41,3.17-1-.16-1.32-1.24-1.65-2Z"
                />
                <g>
                  <path
                    className="clss-5"
                    d="M315.48,373.7c-1.71.9-2.93,2-2,3.8l1.32,2.47a3.47,3.47,0,0,0,4.95,1.52,3.56,3.56,0,0,0,1.52-4.95L320,374.07C319,372.28,317.47,372.65,315.48,373.7Z"
                  />
                  <path
                    className="clss-6"
                    d="M316.56,375.37c-1.64.94-4,.34-3.07,2.13l1.32,2.47a3.47,3.47,0,0,0,4.95,1.52,3.56,3.56,0,0,0,1.52-4.95L320,374.07C319,372.28,318.52,374.25,316.56,375.37Z"
                  />
                </g>
              </g>
            </g>
          </g>
          <svg id="bandera" x="-98px" y="50px" viewBox="0 0 550 550" {...props}>
            <g id="logoColor" className="logoColor">
              <rect x={113} y={132.5} width={223.2} height={97.2} />
            </g>
            <g id="mantoGroup3" className="mantoInvisible mantoGroup3">
              <path
                id="contraforma13"
                d="M289.9,180.1c-1.6,0.2-3,1.1-4.1,2.4c-1.1,1.4-1.7,3.3-1.7,5.6c0,2.3,0.6,4,1.7,5.1 c1.1,1.1,2.5,1.5,4.1,1.3c1.6-0.2,3-1.1,4.1-2.5c1.1-1.4,1.6-3.3,1.6-5.7c0-2.3-0.5-4-1.6-5.1C292.9,180.2,291.5,179.8,289.9,180.1 z"
              />
              <path
                id="contraforma03"
                d="M212.7,184.9c-1.6,0-3,0.6-4.1,1.8c-1.1,1.2-1.7,3-1.7,5.3c0,2.3,0.6,4.1,1.7,5.4 c1.1,1.3,2.5,1.9,4.1,1.9c1.6,0,3-0.6,4.1-1.8c1.1-1.2,1.7-3,1.7-5.4c0-2.3-0.6-4.1-1.7-5.3C215.7,185.5,214.4,184.9,212.7,184.9z"
              />
              <path
                id="manto3"
                d="M220.8,115.1c-53.4-1-88.9-16.1-120-15.8c0,18.1,0,124,0,142.9c27.2,1.1,79.5,18.9,120,18.8 c40.4-0.1,79.8-14.4,120-12.4c0-21.2,0-125.8,0-146C284.8,106,254,115.8,220.8,115.1z M164.4,196.3c-1,1.5-2.5,2.5-4.4,3.1 c-1.9,0.5-4.2,0.6-7,0.2c-4.1-0.6-7.2-2-9.4-4.3c-2.2-2.3-3.5-5.3-3.9-9c2.1,0.2,4.2,0.3,6.3,0.4c0.4,2.2,1.2,3.9,2.3,5.1 c1.2,1.2,2.7,1.9,4.7,2.2c2.1,0.3,3.7,0.1,4.8-0.7c1.1-0.7,1.6-1.7,1.6-2.9c0-0.8-0.2-1.4-0.7-2c-0.4-0.6-1.2-1.2-2.4-1.7 c-0.8-0.4-2.5-1.1-5.2-2.2c-3.5-1.4-5.9-2.9-7.4-4.4c-2-2.1-3-4.5-3-7c0-1.7,0.5-3.1,1.4-4.4c0.9-1.3,2.3-2.2,4-2.6 c1.8-0.5,3.9-0.5,6.4-0.2c4.1,0.6,7.1,1.9,9.2,3.9c2.1,2,3.1,4.6,3.2,7.5c-2.2-0.2-4.4-0.3-6.5-0.5c-0.3-1.7-0.9-3-1.8-3.8 c-0.9-0.9-2.3-1.4-4.1-1.7c-1.9-0.3-3.4-0.1-4.4,0.5c-0.7,0.4-1,1-1,1.9c0,0.8,0.3,1.5,1,2.1c0.8,0.8,2.8,1.9,6,3.1 c3.2,1.2,5.5,2.3,7,3.3c1.5,1,2.7,2.2,3.6,3.7c0.9,1.5,1.3,3.3,1.3,5.3C165.9,193.1,165.4,194.8,164.4,196.3z M174.2,201.6 c-2.1-0.2-4.1-0.4-6.2-0.7c0-7.8,0-15.7,0-23.5c2.1,0.2,4.1,0.5,6.2,0.7C174.2,185.9,174.2,193.7,174.2,201.6z M174.2,174.9 c-2.1-0.2-4.1-0.4-6.2-0.7c0-1.9,0-3.8,0-5.8c2.1,0.2,4.1,0.5,6.2,0.7C174.2,171,174.2,173,174.2,174.9z M185.4,203.1 c-1.1-0.1-2.1-0.4-3-0.8c-0.9-0.4-1.6-1-2-1.6c-0.4-0.6-0.7-1.5-0.9-2.5c-0.1-0.7-0.2-2.2-0.2-4.4c0-3.4,0-6.8,0-10.2 c-1-0.1-1.9-0.2-2.9-0.3c0-1.7,0-3.3,0-5c1,0.1,1.9,0.2,2.9,0.3c0-1.6,0-3.1,0-4.7c2.1-1,4.2-2.1,6.2-3.1c0,2.8,0,5.5,0,8.3 c1.4,0.1,2.8,0.2,4.3,0.3c0,1.7,0,3.3,0,5c-1.4-0.1-2.8-0.2-4.3-0.3c0,3.2,0,6.3,0,9.5c0,1.9,0,3,0.1,3.4c0.1,0.3,0.3,0.6,0.6,0.8 c0.3,0.2,0.6,0.4,1.1,0.4c0.6,0,1.4-0.1,2.5-0.4c0.2,1.6,0.4,3.2,0.5,4.9C188.9,203,187.3,203.2,185.4,203.1z M198.9,203.4 c-2.1-0.1-4.2-0.2-6.2-0.3c0-7.8,0-15.7,0-23.5c2.1,0.1,4.2,0.2,6.2,0.3C198.9,187.7,198.9,195.5,198.9,203.4z M198.9,176.7 c-2.1-0.1-4.2-0.2-6.2-0.3c0-1.9,0-3.8,0-5.8c2.1,0.1,4.2,0.2,6.2,0.3C198.9,172.9,198.9,174.8,198.9,176.7z M221.5,200.9 c-2.3,2.3-5.2,3.5-8.7,3.4c-2.2,0-4.2-0.6-6.2-1.6c-2-1-3.5-2.5-4.5-4.4c-1-1.9-1.5-4.2-1.5-6.9c0-2.1,0.5-4,1.5-5.9 c1-1.9,2.5-3.3,4.3-4.3c1.9-1,4-1.4,6.3-1.4c3.6,0.1,6.5,1.2,8.8,3.5c2.3,2.3,3.4,5.2,3.4,8.7C224.9,195.6,223.8,198.6,221.5,200.9 z M253.2,187.6c0,3.9-0.2,6.7-0.5,8.3c-0.4,1.6-1,3-2,4.2c-1,1.2-2.2,2.1-3.8,2.9c-1.6,0.7-3.7,1.2-6.3,1.3 c-3.1,0.1-5.5-0.2-7.1-0.8c-1.6-0.7-2.9-1.6-3.8-2.7c-0.9-1.1-1.5-2.3-1.8-3.6c-0.4-1.9-0.6-4.6-0.6-8.2c0-3.9,0-7.7,0-11.6 c-1.1,0-2.2,0-3.3,0c0-0.8,0-1.7,0-2.5c1.3-1.3,2-2,3.3-3.3c0,0,0,0,0,0c0,0,0,0,0,0c1,0,2,0,3,0c1.2,0,2.4-0.1,3.6-0.1 c0,5.9,0,11.7,0,17.6c0,2.8,0.1,4.6,0.2,5.4c0.3,1.3,1,2.4,2,3.1c1.1,0.8,2.5,1.1,4.3,1c1.9-0.1,3.3-0.5,4.2-1.3 c0.9-0.8,1.5-1.8,1.7-2.9c0.2-1.1,0.3-3,0.3-5.5c0-6,0-12,0-18c2.2-0.1,4.4-0.3,6.6-0.4C253.2,176.2,253.2,181.9,253.2,187.6z M276.4,200.6c-2.1,0.2-4.1,0.5-6.2,0.7c0-4,0-8,0-12c0-2.5-0.1-4.2-0.4-4.9c-0.3-0.7-0.7-1.3-1.3-1.6c-0.6-0.4-1.3-0.5-2.2-0.4 c-1.1,0.1-2,0.5-2.9,1.2c-0.9,0.7-1.4,1.5-1.8,2.5c-0.3,1-0.5,2.8-0.5,5.4c0,3.5,0,7.1,0,10.6c-2.1,0.2-4.2,0.3-6.2,0.5 c0-7.8,0-15.7,0-23.5c1.9-0.1,3.9-0.3,5.8-0.5c0,1.2,0,2.3,0,3.5c2.1-2.8,4.6-4.4,7.8-4.7c1.4-0.1,2.6,0,3.8,0.3 c1.1,0.4,2,0.9,2.6,1.6c0.6,0.7,1,1.5,1.2,2.5c0.2,0.9,0.3,2.3,0.3,4.1C276.4,190.9,276.4,195.7,276.4,200.6z M298.6,194.7 c-2.3,2.7-5.2,4.4-8.6,4.9c-2.1,0.3-4.2,0.1-6.1-0.6c-1.9-0.7-3.4-2-4.4-3.7c-1-1.8-1.5-4-1.5-6.7c0-2.1,0.5-4.1,1.5-6.2 c1-2.1,2.5-3.7,4.3-5c1.9-1.3,3.9-2.1,6.2-2.4c3.5-0.5,6.4,0.2,8.7,2.1c2.3,1.9,3.4,4.6,3.4,8.2C302,188.8,300.9,192,298.6,194.7z"
              />
            </g>
            <g id="mantoGroup2" className="mantoInvisible mantoGroup2">
              <path
                id="contraforma12"
                d="M293.9,174.5c-1.1-0.9-2.5-1.2-4.1-0.8c-1.6,0.4-3,1.3-4.1,2.7c-1.1,1.4-1.7,3.3-1.7,5.6 c0,2.3,0.6,4,1.7,5.1c1.1,1,2.5,1.4,4.1,1c1.6-0.4,3-1.4,4.1-2.9c1.1-1.6,1.6-3.5,1.6-5.9C295.6,177,295,175.4,293.9,174.5z"
              />
              <path
                id="contraforma02"
                d="M212.8,168c-1.6-0.3-3,0-4.1,1.1c-1.1,1-1.7,2.7-1.7,5.1c0,2.3,0.6,4.2,1.7,5.7 c1.1,1.4,2.5,2.3,4.1,2.6c1.6,0.3,3,0,4.1-1.1c1.1-1,1.6-2.7,1.6-5.1c0-2.3-0.5-4.2-1.6-5.6C215.8,169.2,214.4,168.3,212.8,168z"
              />
              <path
                id="manto2"
                d="M220.8,98.6c-54.4-13-107.9-5.9-120-3c0,18.1,0,127.8,0,146.7c28.9-8.3,74.7-9.2,120,0.6 c45.5,9.9,81.9,9.8,120,5.7c0-21.2,0-125.8,0-146C290.3,107.7,252.3,106.1,220.8,98.6z M164.5,178.5c-1,1.7-2.5,3.1-4.4,4.1 c-1.9,1-4.2,1.8-7.1,2.4c-4.1,0.9-7.3,0.9-9.5-0.2c-2.2-1.1-3.5-3.4-3.9-6.8c2.1-1.1,4.2-2,6.4-2.9c0.4,2,1.2,3.4,2.3,4 c1.2,0.7,2.8,0.8,4.7,0.3c2.1-0.5,3.7-1.2,4.8-2.2c1.1-1.1,1.6-2.2,1.6-3.4c0-0.8-0.2-1.4-0.7-1.9c-0.5-0.5-1.2-0.8-2.4-1 c-0.8-0.1-2.5-0.3-5.2-0.3c-3.5,0-6-0.3-7.4-1.1c-2-1.1-3-2.9-3-5.5c0-1.7,0.5-3.4,1.4-5.2c0.9-1.8,2.3-3.3,4.1-4.6 c1.8-1.3,3.9-2.3,6.4-2.8c4.1-0.9,7.1-0.4,9.2,1.1c2.1,1.5,3.1,3.9,3.2,6.8c-2.2,0.3-4.4,0.6-6.6,1.1c-0.3-1.6-0.9-2.7-1.8-3.3 c-0.9-0.6-2.3-0.7-4.2-0.3c-1.9,0.4-3.4,1.2-4.5,2.3c-0.7,0.7-1,1.5-1,2.3c0,0.8,0.3,1.3,1,1.7c0.8,0.5,2.8,0.6,6,0.7 c3.2,0.1,5.5,0.6,7.1,1.2c1.5,0.6,2.7,1.6,3.6,2.9c0.9,1.3,1.3,3,1.3,5.1C166,175,165.5,176.8,164.5,178.5z M174.3,182.3 c-2.1,0-4.1,0-6.2,0.2c0-7.8,0-15.7,0-23.5c2.1-0.1,4.1-0.2,6.2-0.2C174.3,166.7,174.3,174.5,174.3,182.3z M174.3,155.7 c-2.1,0-4.1,0-6.2,0.2c0-1.9,0-3.8,0-5.8c2.1-0.1,4.1-0.2,6.2-0.2C174.3,151.8,174.3,153.7,174.3,155.7z M185.6,183.4 c-1.1-0.1-2.1-0.4-3-0.8c-0.9-0.4-1.6-1-2-1.6c-0.4-0.6-0.7-1.4-0.9-2.5c-0.1-0.7-0.2-2.2-0.2-4.4c0-3.4,0-6.8,0-10.2 c-1,0-1.9-0.1-2.9-0.1c0-1.7,0-3.3,0-5c1,0,1.9,0.1,2.9,0.1c0-1.6,0-3.1,0-4.7c2.1-1.1,4.2-2.2,6.2-3.2c0,2.8,0,5.5,0,8.3 c1.4,0.1,2.8,0.3,4.2,0.4c0,1.7,0,3.3,0,5c-1.4-0.2-2.8-0.3-4.2-0.4c0,3.2,0,6.3,0,9.5c0,1.9,0,3,0.1,3.4c0.1,0.3,0.3,0.6,0.6,0.8 c0.3,0.2,0.6,0.4,1.1,0.4c0.6,0.1,1.4-0.1,2.5-0.3c0.2,1.6,0.4,3.3,0.5,4.9C189,183.4,187.4,183.6,185.6,183.4z M199,184.5 c-2.1-0.3-4.1-0.6-6.2-0.9c0-7.8,0-15.7,0-23.5c2.1,0.3,4.1,0.6,6.2,0.9C199,168.9,199,176.7,199,184.5z M199,157.8 c-2.1-0.3-4.1-0.6-6.2-0.9c0-1.9,0-3.8,0-5.8c2.1,0.3,4.1,0.6,6.2,0.9C199,154,199,155.9,199,157.8z M221.5,185.7 c-2.3,1.9-5.2,2.5-8.7,1.8c-2.2-0.4-4.2-1.3-6.2-2.6c-2-1.3-3.4-3-4.5-5.1c-1-2.1-1.5-4.4-1.5-7.1c0-2.1,0.5-4,1.5-5.7 c1-1.8,2.5-3,4.3-3.7c1.9-0.7,4-0.8,6.3-0.4c3.6,0.7,6.5,2.4,8.7,5.2c2.3,2.8,3.4,5.9,3.4,9.4C224.9,181.1,223.8,183.9,221.5,185.7 z M253.1,178.8c0,3.9-0.2,6.6-0.5,8.2c-0.4,1.6-1,2.9-2,3.9c-1,1-2.2,1.7-3.8,2.2c-1.6,0.4-3.7,0.5-6.2,0c-3.1-0.5-5.4-1.3-7.1-2.3 c-1.6-1-2.9-2.2-3.8-3.5c-0.9-1.3-1.5-2.6-1.8-4c-0.4-1.9-0.6-4.7-0.6-8.4c0-3.9,0-7.7,0-11.6c-1.1-0.2-2.2-0.4-3.3-0.6 c0-0.8,0-1.7,0-2.5c1.3-1,2-1.6,3.3-2.6c0,0,0,0,0,0c0,0,0,0,0,0c1,0.2,2,0.4,2.9,0.6c1.2,0.2,2.4,0.5,3.6,0.7c0,5.9,0,11.7,0,17.6 c0,2.8,0.1,4.6,0.2,5.5c0.3,1.4,0.9,2.6,2,3.6c1.1,1,2.5,1.6,4.3,2c1.9,0.3,3.3,0.1,4.2-0.5c0.9-0.6,1.5-1.5,1.7-2.6 c0.2-1.1,0.3-2.9,0.3-5.5c0-6,0-12,0-18c2.2,0.3,4.4,0.6,6.6,0.8C253.1,167.5,253.1,173.1,253.1,178.8z M276.3,194.5 c-2.1,0.2-4.1,0.3-6.2,0.3c0-4,0-8,0-12c0-2.5-0.1-4.2-0.4-4.9c-0.3-0.7-0.7-1.3-1.3-1.7c-0.6-0.4-1.3-0.6-2.2-0.6 c-1.1,0-2,0.3-2.9,0.8c-0.9,0.6-1.4,1.3-1.8,2.3c-0.3,1-0.5,2.7-0.5,5.4c0,3.5,0,7.1,0,10.6c-2.1-0.1-4.1-0.3-6.2-0.5 c0-7.8,0-15.7,0-23.5c1.9,0.2,3.9,0.3,5.8,0.4c0,1.2,0,2.3,0,3.5c2.1-2.5,4.6-3.8,7.7-3.8c1.4,0,2.6,0.2,3.8,0.7 c1.1,0.4,2,1,2.6,1.8c0.6,0.7,1,1.6,1.2,2.5c0.2,1,0.3,2.3,0.3,4.2C276.3,184.7,276.3,189.6,276.3,194.5z M298.5,187.1 c-2.3,3.1-5.2,5.2-8.7,6c-2.2,0.5-4.2,0.4-6.2-0.2c-2-0.7-3.4-1.9-4.5-3.7c-1-1.8-1.5-4-1.5-6.7c0-2.1,0.5-4.1,1.5-6.2 c1-2,2.5-3.7,4.3-5c1.9-1.3,4-2.2,6.3-2.7c3.6-0.8,6.5-0.6,8.7,0.9c2.3,1.5,3.4,3.9,3.4,7.5C302,180.6,300.8,184,298.5,187.1z"
              />
            </g>
            <g id="mantoGroup1" className="mantoInvisible mantoGroup1">
              <path
                id="contraforma11"
                d="M286.4,167c-1.6-0.2-3,0.2-4.1,1.3c-1.1,1.1-1.7,2.8-1.7,5.1c0,2.3,0.6,4.2,1.7,5.6 c1.1,1.4,2.5,2.2,4.1,2.4c1.6,0.2,3-0.2,4.1-1.2c1.1-1.1,1.6-2.8,1.6-5.1c0-2.3-0.5-4.2-1.6-5.6C289.4,168,288,167.2,286.4,167z"
              />
              <path
                id="contraforma01"
                d="M209.2,161.7c-1.6,0-3,0.7-4.1,1.9c-1.1,1.3-1.7,3.1-1.7,5.4c0,2.3,0.6,4.1,1.7,5.3 c1.1,1.2,2.5,1.8,4.1,1.8c1.6,0,3-0.7,4.1-1.9c1.1-1.2,1.7-3.1,1.7-5.4c0-2.3-0.6-4.1-1.7-5.3C212.2,162.3,210.9,161.7,209.2,161.7 z"
              />
              <path
                id="manto1"
                d="M218.9,90.1c-48.5,0-93.6,17.4-118.1,17.4c0,18.1,0,126.5,0,145.4c27.6,0,74-19.5,120-19.6 c46.6-0.1,67.7,15,120,15c0-21.2,0-125.5,0-145.7C309.9,102.6,267,90.1,218.9,90.1z M160.9,179.8c-1,1.7-2.5,3.1-4.4,4.2 c-1.9,1-4.2,1.7-7,2.2c-4.1,0.6-7.2,0.2-9.4-1.4c-2.2-1.5-3.5-4.1-3.9-7.6c2.1-0.6,4.2-1.1,6.3-1.7c0.4,2.1,1.2,3.5,2.3,4.3 c1.2,0.8,2.7,1.1,4.7,0.8c2.1-0.3,3.7-1,4.8-2c1.1-1,1.6-2.1,1.6-3.3c0-0.8-0.2-1.4-0.7-1.9c-0.4-0.5-1.2-0.8-2.4-1.1 c-0.8-0.2-2.5-0.4-5.2-0.7c-3.5-0.3-5.9-1-7.4-2.1c-2-1.5-3-3.5-3-6c0-1.7,0.5-3.3,1.4-4.9c0.9-1.6,2.3-2.9,4-3.9 c1.8-1,3.9-1.7,6.4-2.1c4.1-0.6,7.1-0.1,9.2,1.4c2.1,1.5,3.1,3.8,3.2,6.8c-2.2,0.4-4.4,0.7-6.5,1.1c-0.3-1.6-0.9-2.7-1.8-3.4 c-0.9-0.6-2.3-0.8-4.1-0.5c-1.9,0.3-3.4,0.9-4.4,1.8c-0.7,0.6-1,1.3-1,2.2c0,0.8,0.3,1.4,1,1.8c0.8,0.6,2.8,1,6,1.3 c3.2,0.3,5.5,0.8,7,1.4c1.5,0.6,2.7,1.6,3.6,2.9c0.9,1.3,1.3,3,1.3,5C162.4,176.2,161.9,178,160.9,179.8z M170.7,182.9 c-2.1,0.2-4.1,0.4-6.2,0.7c0-7.8,0-15.7,0-23.5c2.1-0.2,4.1-0.5,6.2-0.7C170.7,167.2,170.7,175.1,170.7,182.9z M170.7,156.2 c-2.1,0.2-4.1,0.4-6.2,0.7c0-1.9,0-3.8,0-5.8c2.1-0.2,4.1-0.5,6.2-0.7C170.7,152.4,170.7,154.3,170.7,156.2z M181.9,182.5 c-1.1,0.1-2.1,0-3-0.3c-0.9-0.3-1.6-0.7-2-1.3c-0.4-0.6-0.7-1.3-0.9-2.3c-0.1-0.7-0.2-2.2-0.2-4.4c0-3.4,0-6.8,0-10.2 c-1,0.1-1.9,0.2-2.9,0.3c0-1.7,0-3.3,0-5c1-0.1,1.9-0.2,2.9-0.3c0-1.6,0-3.1,0-4.7c2.1-1.4,4.2-2.8,6.2-4.1c0,2.8,0,5.5,0,8.3 c1.4-0.1,2.8-0.2,4.3-0.3c0,1.7,0,3.3,0,5c-1.4,0.1-2.8,0.2-4.3,0.3c0,3.2,0,6.3,0,9.5c0,1.9,0,3,0.1,3.3c0.1,0.3,0.3,0.6,0.6,0.7 c0.3,0.2,0.6,0.3,1.1,0.2c0.6,0,1.4-0.3,2.5-0.8c0.2,1.6,0.4,3.2,0.5,4.8C185.4,181.9,183.8,182.3,181.9,182.5z M195.4,181.1 c-2.1,0.1-4.2,0.2-6.2,0.3c0-7.8,0-15.7,0-23.5c2.1-0.1,4.2-0.2,6.2-0.3C195.4,165.4,195.4,173.3,195.4,181.1z M195.4,154.4 c-2.1,0.1-4.2,0.2-6.2,0.3c0-1.9,0-3.8,0-5.8c2.1-0.1,4.2-0.2,6.2-0.3C195.4,150.6,195.4,152.5,195.4,154.4z M218,177.6 c-2.3,2.3-5.2,3.5-8.7,3.6c-2.2,0-4.2-0.4-6.2-1.3c-2-0.9-3.5-2.3-4.5-4.1c-1-1.8-1.5-4.1-1.5-6.8c0-2.1,0.5-4.1,1.5-6.1 c1-2,2.5-3.5,4.3-4.6c1.9-1.1,4-1.6,6.3-1.7c3.6-0.1,6.5,1.1,8.8,3.4c2.3,2.3,3.4,5.2,3.4,8.8C221.4,172.4,220.3,175.3,218,177.6z M249.7,166.5c0,3.9-0.2,6.6-0.5,8.2c-0.4,1.6-1,2.9-2,3.9c-1,1-2.2,1.8-3.8,2.4c-1.6,0.6-3.7,0.8-6.3,0.7 c-3.1-0.1-5.5-0.6-7.1-1.3c-1.6-0.8-2.9-1.7-3.8-2.9c-0.9-1.2-1.5-2.4-1.8-3.6c-0.4-1.9-0.6-4.6-0.6-8.2c0-3.9,0-7.7,0-11.6 c-1.1,0-2.2,0-3.3,0c0-0.8,0-1.7,0-2.5c1.3-1.3,2-2,3.3-3.2c0,0,0,0,0,0c0,0,0,0,0,0c1,0,2,0,3,0c1.2,0,2.4,0.1,3.6,0.1 c0,5.9,0,11.7,0,17.6c0,2.8,0.1,4.6,0.2,5.4c0.3,1.3,1,2.4,2,3.3c1.1,0.8,2.5,1.3,4.3,1.4c1.9,0.1,3.3-0.2,4.2-0.9 c0.9-0.7,1.5-1.6,1.7-2.7c0.2-1.1,0.3-2.9,0.3-5.5c0-6,0-12,0-18c2.2,0.1,4.4,0.3,6.6,0.4C249.7,155.2,249.7,160.8,249.7,166.5z M272.9,183.9c-2.1-0.2-4.1-0.5-6.2-0.7c0-4,0-8,0-12c0-2.5-0.1-4.2-0.4-5c-0.3-0.8-0.7-1.4-1.3-1.9c-0.6-0.5-1.3-0.8-2.2-0.8 c-1.1-0.1-2,0.1-2.9,0.6c-0.9,0.5-1.4,1.2-1.8,2.2c-0.3,0.9-0.5,2.7-0.5,5.4c0,3.5,0,7.1,0,10.6c-2.1-0.2-4.2-0.3-6.2-0.5 c0-7.8,0-15.7,0-23.5c1.9,0.1,3.9,0.3,5.8,0.5c0,1.2,0,2.3,0,3.5c2.1-2.5,4.6-3.6,7.8-3.3c1.4,0.1,2.6,0.5,3.8,1.1 c1.1,0.6,2,1.3,2.6,2.2c0.6,0.8,1,1.8,1.2,2.8c0.2,1,0.3,2.4,0.3,4.2C272.9,174.2,272.9,179,272.9,183.9z M295.1,184.3 c-2.3,2-5.2,2.7-8.6,2.2c-2.1-0.3-4.2-1.1-6.1-2.3c-1.9-1.2-3.4-2.9-4.4-4.9c-1-2-1.5-4.4-1.5-7.1c0-2.1,0.5-4,1.5-5.8 c1-1.8,2.5-3.1,4.3-3.9c1.9-0.8,3.9-1,6.2-0.6c3.5,0.5,6.4,2.1,8.7,4.8c2.3,2.7,3.4,5.8,3.4,9.3 C298.5,179.6,297.3,182.4,295.1,184.3z"
              />
            </g>
            <g id="mantoGroup0" className="mantoGroup0">
              <path
                id="contraforma10"
                d="M290.2,172.7c-1.6-0.3-3,0.1-4.1,1.2c-1.1,1.1-1.7,2.8-1.7,5.2c0,2.3,0.6,4.2,1.7,5.6 c1.1,1.4,2.5,2.2,4.1,2.5c1.6,0.3,3-0.1,4.1-1.1c1.1-1,1.7-2.7,1.7-5.1c0-2.3-0.6-4.2-1.7-5.7C293.2,173.8,291.8,172.9,290.2,172.7 z"
              />
              <path
                id="contraforma00"
                d="M212.7,176.5c-1.6,0.2-3,1.1-4.1,2.5c-1.1,1.4-1.7,3.3-1.7,5.6c0,2.3,0.6,4.1,1.7,5.2 c1.1,1.1,2.5,1.5,4.1,1.3c1.6-0.2,3-1.1,4.1-2.5c1.1-1.4,1.7-3.3,1.7-5.7c0-2.3-0.6-4-1.7-5.1C215.7,176.7,214.4,176.2,212.7,176.5 z"
              />
              <path
                id="manto0"
                d="M218.9,106.1c-47.5,10.6-93.5,13.4-118.1,5.7c0,18.1,0,125.3,0,144.2c27.8,5.4,75,5.4,120-5.9 c45.2-11.3,81.5-12.4,120-1.4c0-21.2,0-125.8,0-146C279,91,250.5,99,218.9,106.1z M164.2,194.5c-1,1.6-2.5,2.7-4.4,3.3 c-1.9,0.6-4.3,0.7-7.1,0.3c-4.1-0.7-7.3-2.4-9.5-4.8c-2.2-2.5-3.5-5.7-4-9.4c2.1,0.4,4.3,0.8,6.4,1.1c0.4,2.2,1.2,4,2.3,5.3 c1.2,1.3,2.8,2.1,4.8,2.4c2.1,0.3,3.7,0.1,4.8-0.7c1.1-0.8,1.6-1.8,1.6-3c0-0.8-0.2-1.5-0.7-2c-0.5-0.6-1.2-1.2-2.4-1.7 c-0.8-0.4-2.5-1.1-5.3-2.2c-3.5-1.5-6-3.2-7.4-4.8c-2-2.3-3-4.8-3-7.4c0-1.7,0.5-3.1,1.4-4.3c0.9-1.2,2.3-1.9,4.1-2.3 c1.8-0.4,3.9-0.3,6.4,0.1c4.1,0.7,7.2,1.9,9.2,3.9c2.1,2,3.2,4.4,3.3,7.4c-2.2,0-4.4-0.1-6.6-0.3c-0.3-1.7-0.9-3-1.8-3.8 c-0.9-0.9-2.3-1.4-4.2-1.7c-1.9-0.3-3.4-0.2-4.5,0.3c-0.7,0.4-1,1-1,1.8c0,0.8,0.3,1.5,1,2.2c0.8,0.9,2.8,2,6,3.3 c3.2,1.2,5.6,2.3,7.1,3.2c1.5,1,2.7,2.1,3.6,3.6c0.9,1.5,1.3,3.2,1.3,5.3C165.8,191.2,165.3,192.9,164.2,194.5z M174.1,199 c-2.1,0-4.2,0-6.2-0.1c0-7.9,0-15.7,0-23.6c2.1,0.1,4.2,0.1,6.2,0.1C174.1,183.3,174.1,191.2,174.1,199z M174.1,172.2 c-2.1,0-4.2,0-6.2-0.1c0-1.9,0-3.9,0-5.8c2.1,0.1,4.2,0.1,6.2,0.1C174.1,168.4,174.1,170.3,174.1,172.2z M185.4,199.2 c-1.1,0.1-2.1-0.1-3-0.4c-0.9-0.3-1.6-0.8-2-1.4c-0.4-0.6-0.7-1.4-0.9-2.4c-0.1-0.7-0.2-2.2-0.2-4.4c0-3.4,0-6.9,0-10.3 c-1,0-1.9,0.1-2.9,0.1c0-1.7,0-3.3,0-5c1,0,1.9,0,2.9-0.1c0-1.6,0-3.1,0-4.7c2.1-1.3,4.2-2.6,6.3-4c0,2.8,0,5.6,0,8.3 c1.4-0.1,2.8-0.2,4.3-0.3c0,1.7,0,3.3,0,5c-1.4,0.1-2.8,0.2-4.3,0.3c0,3.2,0,6.3,0,9.5c0,1.9,0,3,0.1,3.4c0.1,0.3,0.3,0.6,0.6,0.8 c0.3,0.2,0.6,0.3,1.1,0.2c0.6,0,1.4-0.3,2.5-0.8c0.2,1.6,0.4,3.2,0.5,4.8C188.9,198.6,187.2,199.1,185.4,199.2z M198.9,197.4 c-2.1,0.2-4.2,0.5-6.2,0.7c0-7.9,0-15.7,0-23.6c2.1-0.2,4.2-0.4,6.2-0.7C198.9,181.7,198.9,189.5,198.9,197.4z M198.9,170.6 c-2.1,0.2-4.2,0.5-6.2,0.7c0-1.9,0-3.9,0-5.8c2.1-0.2,4.2-0.4,6.2-0.7C198.9,166.7,198.9,168.6,198.9,170.6z M221.5,191.3 c-2.3,2.7-5.2,4.3-8.7,4.8c-2.2,0.3-4.2,0.1-6.2-0.6c-2-0.7-3.5-2-4.5-3.7c-1-1.8-1.5-4-1.5-6.7c0-2.1,0.5-4.1,1.5-6.2 c1-2.1,2.5-3.7,4.3-5c1.9-1.3,4-2.1,6.3-2.4c3.6-0.5,6.5,0.2,8.8,2.2c2.3,2,3.4,4.7,3.4,8.3C224.9,185.4,223.8,188.6,221.5,191.3z M253.3,175c0,3.9-0.2,6.7-0.5,8.3c-0.4,1.6-1,3.1-2,4.3c-1,1.2-2.2,2.2-3.8,3c-1.6,0.8-3.7,1.4-6.3,1.7c-3.1,0.4-5.5,0.3-7.1-0.1 c-1.6-0.5-2.9-1.2-3.8-2.3c-0.9-1-1.5-2.1-1.8-3.3c-0.4-1.8-0.6-4.5-0.6-8.2c0-3.9,0-7.7,0-11.6c-1.1,0.2-2.2,0.3-3.3,0.5 c0-0.8,0-1.7,0-2.5c1.3-1.5,2-2.3,3.3-3.8c0,0,0,0,0,0c0,0,0,0,0,0c1-0.1,2-0.3,3-0.4c1.2-0.2,2.4-0.3,3.6-0.5c0,5.9,0,11.8,0,17.7 c0,2.8,0.1,4.6,0.2,5.4c0.3,1.3,1,2.3,2,2.9c1.1,0.7,2.5,0.9,4.3,0.7c1.9-0.2,3.3-0.8,4.2-1.6c0.9-0.9,1.5-1.9,1.7-3 c0.2-1.1,0.3-3,0.3-5.6c0-6,0-12,0-18c2.2-0.2,4.4-0.4,6.6-0.6C253.3,163.6,253.3,169.3,253.3,175z M276.6,189.9 c-2.1-0.1-4.2-0.2-6.2-0.2c0-4,0-8,0-12.1c0-2.5-0.1-4.2-0.4-5c-0.3-0.8-0.7-1.3-1.3-1.8c-0.6-0.4-1.3-0.6-2.2-0.6 c-1.1,0-2.1,0.3-2.9,0.9c-0.9,0.6-1.4,1.4-1.8,2.4c-0.3,1-0.5,2.8-0.5,5.4c0,3.6,0,7.1,0,10.7c-2.1,0.1-4.2,0.2-6.2,0.3 c0-7.9,0-15.7,0-23.6c1.9-0.1,3.9-0.2,5.8-0.3c0,1.2,0,2.3,0,3.5c2.1-2.8,4.7-4.2,7.8-4.2c1.4,0,2.6,0.3,3.8,0.8 c1.1,0.5,2,1.2,2.6,2c0.6,0.8,1,1.7,1.2,2.7c0.2,1,0.3,2.4,0.3,4.2C276.6,180.1,276.6,185,276.6,189.9z M298.9,190.6 c-2.3,1.7-5.2,2.2-8.7,1.6c-2.2-0.4-4.2-1.2-6.2-2.4c-2-1.2-3.5-2.8-4.5-4.8c-1-2-1.5-4.3-1.5-7c0-2.1,0.5-4,1.5-5.9 c1-1.9,2.5-3.2,4.3-4c1.9-0.8,4-1,6.3-0.6c3.6,0.6,6.5,2.5,8.8,5.4c2.3,2.9,3.4,6.2,3.4,9.8C302.4,186.3,301.2,188.9,298.9,190.6z"
              />
            </g>
            <g id="astaBandera">
              <g id="cuerpoDeAsta" className="cuerpoDeAsta">
                <linearGradient
                  id="gradienteDeCuerpoDeAsta"
                  gradientUnits="userSpaceOnUse"
                  x1={347.1}
                  y1={276.5}
                  x2={354.1}
                  y2={276.5}
                >
                  <stop
                    offset={0.4377}
                    style={{
                      stopColor: "#475256",
                    }}
                  />
                  <stop
                    offset={0.695}
                    style={{
                      stopColor: "#3D4649",
                    }}
                  />
                  <stop
                    offset={0.8371}
                    style={{
                      stopColor: "#353D40",
                    }}
                  />
                </linearGradient>
                <rect x={347.1} y={92.6} width={7} height={367.8} />
              </g>
              <g id="puntaDeAsta" className="puntaDeAsta">
                <radialGradient
                  id="gradienteDePuntaDeAsta"
                  cx={349.179}
                  cy={90.6105}
                  r={5.6}
                  gradientUnits="userSpaceOnUse"
                >
                  <stop
                    offset={0.6684}
                    style={{
                      stopColor: "#475256",
                    }}
                  />
                  <stop
                    offset={0.8096}
                    style={{
                      stopColor: "#444E52",
                    }}
                  />
                  <stop
                    offset={0.9528}
                    style={{
                      stopColor: "#3A4246",
                    }}
                  />
                  <stop
                    offset={1}
                    style={{
                      stopColor: "#353D40",
                    }}
                  />
                </radialGradient>
                <path d="M350.6,87c3.1,0,5.6,2.5,5.6,5.6 s-2.5,5.6-5.6,5.6s-5.6-2.5-5.6-5.6S347.5,87,350.6,87z" />
              </g>
              <g id="gachillos" className="ganchillos">
                <path
                  id="gachilloDeAstaSuperior"
                  d="M329.6,127.1L329.6,127.1c0-1.7,1.4-3.1,3.1-3.1h21.4v6.3h-21.4C331,130.3,329.6,128.9,329.6,127.1z"
                />
                <path
                  id="gachilloDeAstaInferior"
                  d="M329.6,218L329.6,218c0-1.7,1.4-3.1,3.1-3.1h21.4v6.3h-21.4C331,221.2,329.6,219.8,329.6,218z"
                />
              </g>
            </g>
          </svg>
          <path
            id="banderaGuia"
            d="M299.78,174.18A4.39,4.39,0,0,0,297,182v21.25H292v-9.73h0s-3.49,1.1-9.39,2.52-14.19,3.19-23.79,4.52l-1.81.24q-2.74.36-5.61.67c-4.46.46-9.11.81-13.88,1-1.36.05-2.72.08-4.1.1a150,150,0,0,1-18.77-.9c-1.39-.16-2.78-.35-4.16-.56-2.08-.31-4.14-.67-6.18-1.1a93.57,93.57,0,0,1-10-2.66,113.41,113.41,0,0,0-18.09-4.3c-2.71-.42-5.38-.73-8-1l-.9-.07c-2.73-.22-5.41-.33-8-.37h-.7c-1,0-2,0-3,0s-2.22.05-3.3.09-2.15.1-3.2.17c-2.1.13-4.14.31-6.1.53-1,.1-1.94.22-2.88.34-1.88.25-3.69.53-5.4.82a110.8,110.8,0,0,0-20.24,5.27v92.8h0a117.82,117.82,0,0,1,26.92-6.25l1.6-.19q2.21-.24,4.53-.42l1.57-.11c1.05-.07,2.12-.12,3.2-.16s2.18-.08,3.3-.09l1.68,0c2.82,0,5.73.08,8.71.28a116.27,116.27,0,0,1,28.34,5.43c2.62.86,5.28,1.59,8,2.22s5.45,1.13,8.22,1.55c1.19.18,2.39.34,3.59.48.89.11,1.77.21,2.66.3l2.09.19c1.23.1,2.46.18,3.69.25l2.59.13,2.08.06q3.13.09,6.23,0c.69,0,1.37,0,2.06,0,2.61-.07,5.2-.19,7.74-.35,1.45-.1,2.89-.21,4.31-.33.65-.05,1.3-.11,1.94-.18,2.58-.24,5.1-.53,7.54-.85l1.81-.25c2.41-.33,4.72-.69,6.94-1.06l3.26-.57,3.09-.59c1-.19,2-.39,2.92-.59l1.39-.29c.91-.19,1.79-.39,2.63-.58l2.43-.56c4.64-1.1,8-2,9.53-2.49l.63-.19.36-.11v-6.66H297V500.06h5.48V274.76h0V208.21h0v-4.93h0V182a4.4,4.4,0,0,0-2.74-7.85ZM297,274.76H292V208.21H297Z"
          />
          <g id="leftHandClosedFingers">
            <g>
              <path
                className="clss-5"
                d="M292.87,386.77c-.93-6,4.82-9.12,10-9.48a3.57,3.57,0,0,1,1,7.08,8.37,8.37,0,0,1-2.23-.18c-1.75-.18-4.08-.14-4.67,1.82-.05.11-.07.32-.11.29a2,2,0,1,1-4,.47Z"
              />
              <g>
                <path
                  className="clss-5"
                  d="M301.74,380.54c-.5-1.73-1.29-3.05-3.1-2.52l-2.5.73a3.24,3.24,0,0,0-2.32,4.23,3.31,3.31,0,0,0,4.23,2.32l2.51-.73C302.37,384,302.32,382.56,301.74,380.54Z"
                />
                <path
                  className="clss-6"
                  d="M300,381.22c-.55-1.67.44-3.73-1.37-3.2l-2.5.73a3.24,3.24,0,0,0-2.32,4.23,3.31,3.31,0,0,0,4.23,2.32l2.51-.73C302.37,384,300.66,383.22,300,381.22Z"
                />
              </g>
            </g>
            <g>
              <path
                className="clss-5"
                d="M292.11,394c.51-6.09,6.83-7.73,11.94-6.86a3.57,3.57,0,0,1-.71,7.11,8.38,8.38,0,0,1-2.12-.7c-1.66-.59-3.94-1.09-5,.67-.08.09-.15.29-.18.25a2,2,0,1,1-4-.47Z"
              />
              <g>
                <path
                  className="clss-5"
                  d="M302.19,390.06c-.08-1.8-.53-3.27-2.41-3.18l-2.61.12a3.25,3.25,0,0,0-3.25,3.57,3.32,3.32,0,0,0,3.57,3.25l2.6-.12C302,393.61,302.28,392.16,302.19,390.06Z"
                />
                <path
                  className="clss-6"
                  d="M300.35,390.31c-.14-1.75,1.31-3.52-.57-3.43l-2.61.12a3.25,3.25,0,0,0-3.25,3.57,3.32,3.32,0,0,0,3.57,3.25l2.6-.12C302,393.61,300.51,392.41,300.35,390.31Z"
                />
              </g>
            </g>
            <g>
              <path
                className="clss-5"
                d="M295.13,405.62c-1.6-5,2.93-8.43,7.28-9.4a3.08,3.08,0,0,1,1.77,5.91,7.28,7.28,0,0,1-1.92.13c-1.69.08-3.64.51-3.81,2.43a1.72,1.72,0,0,1-3.32.93Z"
              />
              <g>
                <path
                  className="clss-5"
                  d="M302,399c-.66-1.41-1.5-2.44-3-1.75l-2,1a2.78,2.78,0,0,0-1.42,3.91,2.85,2.85,0,0,0,3.91,1.42l2-.95C303,401.94,302.79,400.68,302,399Z"
                />
                <path
                  className="clss-6"
                  d="M300.64,399.84c-.68-1.35-.11-3.24-1.58-2.55l-2,1a2.78,2.78,0,0,0-1.42,3.91,2.85,2.85,0,0,0,3.91,1.42l2-.95C303,401.94,301.46,401.46,300.64,399.84Z"
                />
              </g>
            </g>
          </g>
        </g>
        <g id="body">
          <g id="_Grupo_" data-name="&lt;Grupo&gt;">
            <path
              className="clss-8"
              d="M432.71,401.52h0c-.81-3.39-17.57-6.57-38.11-6.89s-37.42,2.07-38.26,5.42h0a108.66,108.66,0,0,0-3.52,22.66c-.44,22,17.72,40.46,40.53,40.83s41.69-17,42-39.21C435.51,418.76,434.59,410.77,432.71,401.52Z"
            />
            <ellipse
              className="clss-6"
              cx={394.58}
              cy={400.99}
              rx={6.46}
              ry={38.23}
              transform="translate(-13.81 787.9) rotate(-88.92)"
            />
            <g className="clss-9">
              <g id="neckShadow" className="clss-10">
                <ellipse
                  className="clss-11"
                  cx={382.38}
                  cy={398.09}
                  rx={7.45}
                  ry={44.08}
                  transform="translate(-22.88 772.86) rotate(-88.92)"
                />
              </g>
            </g>
            <g id="logo">
              <g>
                <g>
                  <path
                    className="clss-12"
                    d="M366.63,439.13a.29.29,0,0,1,0-.09c-.12-3.73-.3-3.89-.23-7.77.71.12,1.07.18,1.81.28,0,.63,0,.92.07,1.46a2.21,2.21,0,0,1,2.33-1.29h0a2.9,2.9,0,0,1,1.2.47,2.73,2.73,0,0,1,.85.88,3.29,3.29,0,0,1,.42,1,8.62,8.62,0,0,1,.16,1.4c.1,1.82.22,2.46.37,4.53-.85,0-1.28,0-2.12-.07-.15-1.82-.25-2.44-.38-3.91a6.94,6.94,0,0,0-.2-1.51,1.6,1.6,0,0,0-.39-.59,1.31,1.31,0,0,0-.58-.28,1.26,1.26,0,0,0-.9.14,1,1,0,0,0-.49.62,5.73,5.73,0,0,0-.06,1.58c.08,1.25.14,1.83.21,3.46-.81-.1-1.22-.16-2-.31C366.67,439.17,366.65,439.15,366.63,439.13Z"
                  />
                  <path
                    className="clss-6"
                    d="M370.71,431.86a2.79,2.79,0,0,1,1.07.44,2.62,2.62,0,0,1,.82.84,3.32,3.32,0,0,1,.4,1,8.62,8.62,0,0,1,.16,1.38c.1,1.82.22,2.47.37,4.54-.82-.06-1.23-.09-2-.18-.11-1.75-.2-2.36-.3-3.79a7.42,7.42,0,0,0-.2-1.54,1.48,1.48,0,0,0-.43-.64,1.25,1.25,0,0,0-.62-.3h-.06a1.34,1.34,0,0,0-.89.15,1.13,1.13,0,0,0-.52.67,5.47,5.47,0,0,0-.06,1.6c.08,1.26.13,1.83.21,3.47-.79-.14-1.17-.22-1.94-.41-.12-3.72-.3-3.89-.23-7.77.68.16,1,.24,1.73.37,0,.58,0,.84,0,1.34a2.49,2.49,0,0,1,2.41-1.16l.12,0m0-.24-.14,0a2.54,2.54,0,0,0-2.25.88c0-.3,0-.45,0-.78a.26.26,0,0,0-.15-.27h0c-.7-.14-1.05-.21-1.73-.38-.09,0-.16.07-.16.2-.08,3.88.11,4,.22,7.77a.34.34,0,0,0,.05.17.24.24,0,0,0,.12.09h0c.76.18,1.15.26,1.94.39.09,0,.17-.07.16-.18-.08-1.63-.13-2.21-.21-3.47a5.15,5.15,0,0,1,.06-1.55,1,1,0,0,1,.45-.58,1.18,1.18,0,0,1,.8-.13H370a1.06,1.06,0,0,1,.53.26,1.25,1.25,0,0,1,.36.53,7.48,7.48,0,0,1,.19,1.48c.1,1.43.18,2,.29,3.8a.25.25,0,0,0,.18.22h0c.81.08,1.21.11,2,.16a.16.16,0,0,0,.17-.18c-.15-2.07-.27-2.71-.37-4.53a9.21,9.21,0,0,0-.16-1.43,3.67,3.67,0,0,0-.44-1.07,2.87,2.87,0,0,0-.89-.92,2.93,2.93,0,0,0-1.12-.48Z"
                  />
                </g>
                <g>
                  <path
                    className="clss-12"
                    d="M361.75,437.67a3.14,3.14,0,0,1-1-.83,4.34,4.34,0,0,1-.73-1.22,6.35,6.35,0,0,1-.34-1.17,8.6,8.6,0,0,1-.09-1.33c0-1,0-1.4,0-2.46-.3-.12-.45-.19-.74-.33,0-.31,0-.47-.07-.81a4.37,4.37,0,0,0,.85-.7c.68.3,1,.45,1.72.71,0,.4,0,.59.06.94,0,1.27,0,1.72,0,2.71a7,7,0,0,0,.13,1.67,1.91,1.91,0,0,0,.33.67,1.65,1.65,0,0,0,.52.44,1.09,1.09,0,0,0,.83.08.76.76,0,0,0,.46-.51,5.48,5.48,0,0,0,.09-1.5c0-1.22-.05-1.78,0-3.51.74.19,1.11.28,1.87.43,0,4,.15,4.09.28,7.91-.74-.16-1.1-.24-1.82-.45,0-.63-.06-.91-.1-1.45a1.55,1.55,0,0,1-2.15.77Z"
                  />
                  <path
                    className="clss-6"
                    d="M365.65,431.07c-.07,3.87.1,4,.19,7.76-.7-.19-1-.29-1.73-.53,0-.57,0-.83,0-1.31a1.74,1.74,0,0,1-2.23.61l-.11-.05a3.21,3.21,0,0,1-.94-.8,4.32,4.32,0,0,1-.7-1.16,5.08,5.08,0,0,1-.32-1.11,9.49,9.49,0,0,1-.1-1.32V430.7c-.32-.17-.49-.26-.81-.45v-.69a4.63,4.63,0,0,0,.83-.64h0c.66.31,1,.46,1.67.73,0,.34,0,.5,0,.8,0,1.26,0,1.71,0,2.71v.22a7.24,7.24,0,0,0,.12,1.47,2.24,2.24,0,0,0,.37.74,1.68,1.68,0,0,0,.56.47l.05,0a1.06,1.06,0,0,0,.83.06.79.79,0,0,0,.48-.54,5.6,5.6,0,0,0,.1-1.53c0-1.23-.05-1.79,0-3.52.71.23,1.06.33,1.79.53m0-.23h0c-.72-.2-1.08-.3-1.78-.52a.09.09,0,0,0-.11,0,.2.2,0,0,0-.05.14c0,1.73,0,2.29,0,3.51a5.31,5.31,0,0,1-.09,1.48.64.64,0,0,1-.43.46.91.91,0,0,1-.73-.06l-.05,0a1.35,1.35,0,0,1-.47-.39,1.54,1.54,0,0,1-.31-.61,6.12,6.12,0,0,1-.12-1.42v-.22c0-1,0-1.45,0-2.71,0-.31,0-.47,0-.81a.53.53,0,0,0,0-.17.24.24,0,0,0-.1-.1h0c-.67-.27-1-.41-1.66-.72a.09.09,0,0,0-.12,0,5.27,5.27,0,0,1-.82.66.11.11,0,0,0,0,.09v.69a.32.32,0,0,0,.13.23h0l.67.37c0,.58,0,.84,0,1.38v.91a8.92,8.92,0,0,0,.09,1.36,5.68,5.68,0,0,0,.35,1.22,4.75,4.75,0,0,0,.76,1.28,3.32,3.32,0,0,0,1,.86l.12.06a1.77,1.77,0,0,0,2.08-.38c0,.29,0,.44,0,.77a.3.3,0,0,0,.16.28h0c.69.23,1,.34,1.74.53.09,0,.16-.06.16-.18-.1-3.76-.27-3.89-.2-7.77a.3.3,0,0,0-.15-.27Z"
                  />
                </g>
                <g>
                  <path
                    className="clss-12"
                    d="M378.15,440.53a4.58,4.58,0,0,1-2-.53,4.16,4.16,0,0,1-1.65-1.48,4.38,4.38,0,0,1-.7-2.13,3.51,3.51,0,0,1,.42-1.9,4,4,0,0,1,1.5-1.6,4.43,4.43,0,0,1,2.26-.63h0a4.3,4.3,0,0,1,4.35,4.29,3.72,3.72,0,0,1-1.11,2.81,4,4,0,0,1-2.94,1.18Zm-.22-6.1a1.74,1.74,0,0,0-1.34.59,2.07,2.07,0,0,0-.46,1.6,2.26,2.26,0,0,0,.67,1.55,1.86,1.86,0,0,0,1.29.56,1.67,1.67,0,0,0,1.36-.52,2.07,2.07,0,0,0,.45-1.57,2.47,2.47,0,0,0-.6-1.62,1.76,1.76,0,0,0-1.29-.59v-.1Z"
                  />
                  <path
                    className="clss-6"
                    d="M378.2,432.38a4,4,0,0,1,2.88,1.26,4.2,4.2,0,0,1,1.19,2.92,3.59,3.59,0,0,1-1.08,2.74,4,4,0,0,1-2.87,1.14h-.18a4.72,4.72,0,0,1-1.94-.52,4.09,4.09,0,0,1-1.61-1.44,4.24,4.24,0,0,1-.68-2.08,3.45,3.45,0,0,1,.41-1.86,3.77,3.77,0,0,1,1.47-1.55,4.33,4.33,0,0,1,2.21-.61h.2m-.1,6.44h.07a1.74,1.74,0,0,0,1.35-.55,2.14,2.14,0,0,0,.47-1.63,2.52,2.52,0,0,0-.62-1.69,1.91,1.91,0,0,0-1.36-.62h-.08a1.88,1.88,0,0,0-1.41.63,2.13,2.13,0,0,0-.48,1.66,2.36,2.36,0,0,0,.69,1.61,2.11,2.11,0,0,0,1.37.59m.12-6.67H378a4.52,4.52,0,0,0-2.31.64,4.09,4.09,0,0,0-1.54,1.66,3.53,3.53,0,0,0-.43,1.93,4.48,4.48,0,0,0,.71,2.18,4.37,4.37,0,0,0,1.69,1.52,4.78,4.78,0,0,0,2,.55h.18a4.11,4.11,0,0,0,3-1.21,3.8,3.8,0,0,0,1.14-2.87,4.47,4.47,0,0,0-1.23-3.06,4.21,4.21,0,0,0-3-1.34Zm-.13,6.5a1.88,1.88,0,0,1-1.23-.53,2.18,2.18,0,0,1-.64-1.5,2,2,0,0,1,.45-1.54,1.64,1.64,0,0,1,1.26-.55H378a1.66,1.66,0,0,1,1.22.55,2.32,2.32,0,0,1,.58,1.56,2,2,0,0,1-.43,1.52,1.52,1.52,0,0,1-1.21.49Z"
                  />
                </g>
              </g>
            </g>
            <path
              className="clss-3"
              d="M356.36,400.26c.76,3.72,14.81,5,18.35,5.52,16.37,1.59,33.06,2,49.38-.38a26.09,26.09,0,0,0,7.11-2c.68-.37,1.5-.86,1.6-1.72-.45,2.6-6.4,3.56-8.63,4.14-16.32,2.9-33.13,2.55-49.55.64-3.7-.6-17.57-2.28-18.26-6.23Z"
            />
          </g>
          <g className="clss-13">
            <g id="innerBodyShadow" className="clss-14">
              <path
                className="clss-11"
                d="M432.71,401.52c9.07,45.84-44.82,66-72.18,45.25a41.54,41.54,0,0,0,32.82,16.77c22.81.38,41.69-17,42-39.21C435.51,418.76,434.59,410.77,432.71,401.52Z"
              />
            </g>
          </g>
        </g>
        <g id="headGroup">
          <g id="leftAntenna">
            <g>
              <polygon
                className="clss-11"
                points="321.47 353.45 322.16 320.33 326.44 320.37 325.75 353.49 321.47 353.45"
              />
              <path
                className="clss-11"
                d="M321.47,353.45c-5.26,0-9.37-7.37-9.18-16.51s4.61-16.58,9.87-16.61,7.11,7.44,6.92,16.58S326.72,353.42,321.47,353.45Z"
              />
              <ellipse
                className="clss-6"
                cx={326.1}
                cy={336.93}
                rx={16.57}
                ry={9.52}
                transform="translate(-21.64 651.47) rotate(-88.07)"
              />
            </g>
            <g>
              <polygon
                className="clss-6"
                points="325.37 357.43 326.24 316.08 331.59 316.13 330.72 357.47 325.37 357.43"
              />
              <path
                className="clss-6"
                d="M325.37,357.43c-6.56,0-11.69-9.2-11.45-20.62s5.75-20.69,12.32-20.72,8.87,9.28,8.63,20.69S331.93,357.4,325.37,357.43Z"
              />
              <ellipse
                className="clss-15"
                cx={331.15}
                cy={336.8}
                rx={20.68}
                ry={11.88}
                transform="matrix(0.03, -1, 1, 0.03, -16.63, 656.4)"
              />
            </g>
            <g>
              <polygon
                className="clss-16"
                points="365.66 258.58 357.19 247.88 354.72 258.74 365.66 258.58"
              />
              <path
                className="clss-17"
                d="M333.32,275.42,334,222.3a2.27,2.27,0,0,1,2.08-2.18l5.7-.42a7.32,7.32,0,0,1,4.4,1.07l7.73,3.77a9.91,9.91,0,0,1,3.29,3.34l6.72,11.27a11.69,11.69,0,0,1,1.67,6l.06,13.46-9.39-3.89s-10.93,31.58-3,61c9.94,36.75-4.34,49.07-16.09,48.07-13.1-1.1-22.72-12.08-21.35-29.35a36.81,36.81,0,0,1,4.19-14.65C328.28,304.67,332.51,294.12,333.32,275.42Z"
              />
              <path
                className="clss-18"
                d="M356.13,344.9c-4.65,28.68-34.72,18.62-31.35-11.43,2.36-21.05,17-24.39,16.71-58.73l2.67-54.83a8.36,8.36,0,0,0-1-.19,10.94,10.94,0,0,0-1.16,0l-5.84.43a2.3,2.3,0,0,0-2.11,2.21l-.69,53.09c-.81,18.7-5,29.25-13.26,44.37a36.81,36.81,0,0,0-4.19,14.65c-1.37,17.27,8.25,28.25,21.35,29.35C350.72,364.6,355.44,351.18,356.13,344.9Z"
              />
            </g>
          </g>
          <g id="head">
            <g id="headBaseGroup">
              <path
                id="headBase"
                className="clss-19"
                d="M470.31,295.54c-13.83-27.48-42.1-41.61-74.76-41.49s-60.19,15-74.51,42.11c-4.08,7.86-1.34,13.65-1.21,35.34s-2.8,29.36,3.78,38.14c14.56,18.7,41.43,26.19,72.44,26,30.83-.12,57.88-7.92,72.26-26.93C481.4,348.91,477.14,311.74,470.31,295.54Z"
              />
              <g className="clss-20">
                <g id="rightAntennaShadow">
                  <path
                    className="clss-21"
                    d="M460.57,274.83V219.16a2.35,2.35,0,0,1,2.06-2.34l5.72-.54a7.21,7.21,0,0,1,4.45,1.06c1.88.8,7.49,3.26,7.49,3.26a10.17,10.17,0,0,1,3.37,3.47l7.25,12.3a9.67,9.67,0,0,1,1.33,5.17l-.39,14.94-8.69-4.08s-10.31,33.7-1.81,64.67c10.61,38.63-3.53,51.87-15.36,51-13.19-1-23.05-12.39-22-30.65a40.29,40.29,0,0,1,4-15.53C456,305.8,460.07,294.59,460.57,274.83Z"
                  />
                </g>
                <g id="headShadow">
                  <g
                    id="_trazado_"
                    data-name="&lt;trazado&gt;"
                    className="clss-14"
                  >
                    <path
                      className="clss-11"
                      d="M318.81,358.41a21.5,21.5,0,0,0,4.33,11.76c14.56,18.7,41.43,26.19,72.44,26,30.83-.13,57.88-7.93,72.26-26.94,12.91-19.74,8.64-56.9,1.82-73.11.55,43.2-20.84,72.89-48.79,85.88-19,8.83-41.73,8.26-60.06,5.5-16.54-2.5-29.46-6.76-37.63-18.34C320.86,365.89,320.06,362.38,318.81,358.41Z"
                    />
                  </g>
                  <g
                    id="_trazado_2"
                    data-name="&lt;trazado&gt;"
                    className="clss-22"
                  >
                    <path
                      className="clss-11"
                      d="M471.5,295.51C457.67,268,429.4,253.91,396.74,254a115.41,115.41,0,0,0-16,1.28c76,11,81.34,71,77.5,93.58Z"
                    />
                  </g>
                </g>
              </g>
            </g>
            <g id="face">
              <g>
                <path
                  className="clss-23"
                  d="M370.77,382.24c-14,0-27.32-3.05-38.38-8.81-5.87-3.06-9.6-10-9.51-17.76l.47-36.94c0-3.94,2.29-7.3,5.46-8.15a149.52,149.52,0,0,1,84.05,1.27c3.15,1,5.32,4.38,5.27,8.33l-.47,37c-.1,7.81-4.07,14.81-9.88,17.43A90.94,90.94,0,0,1,370.77,382.24Z"
                />
                <path
                  className="clss-3"
                  d="M368.69,304.67v1a151.85,151.85,0,0,1,44,6.66c2.89.88,4.95,4.18,4.91,7.84l-.47,37c-.09,7.62-3.94,14.45-9.58,17a90.33,90.33,0,0,1-36.81,7.61c-14,0-27.16-3-38.14-8.76-5.71-3-9.34-9.77-9.25-17.31l.47-36.93c0-3.66,2.19-6.89,5.09-7.68a152.06,152.06,0,0,1,39.74-5.39v-1m0,0a152.77,152.77,0,0,0-40,5.42c-3.37.92-5.78,4.5-5.83,8.64l-.47,36.93c-.1,7.87,3.75,15.07,9.78,18.21,11.46,6,25,8.87,38.61,8.87A91.69,91.69,0,0,0,408,375c6.15-2.76,10.07-10,10.17-17.88l.47-37c.05-4.13-2.27-7.79-5.62-8.8a152.12,152.12,0,0,0-44.33-6.71Z"
                />
              </g>
              <g id="codeScreenReflection" className="clss-24">
                <g className="clss-25">
                  <g id="codeScreenA2">
                    <path
                      className="clss-26"
                      d="M305.71,406H365.1a2.6,2.6,0,0,0,2.56-3.51l-17.34-64.51h-66.4l17.34,64.51A4.93,4.93,0,0,0,305.71,406Z"
                    />
                    <path
                      className="clss-27"
                      d="M283.92,337.93h66.4l-.84-3.13a5,5,0,0,0-4.54-3.58H285.69a2.65,2.65,0,0,0-2.61,3.58Z"
                    />
                    <g>
                      <ellipse
                        className="clss-28"
                        cx={345.27}
                        cy={334.88}
                        rx={0.88}
                        ry={1.15}
                        transform="translate(-134.11 374.32) rotate(-48.83)"
                      />
                      <ellipse
                        className="clss-29"
                        cx={342}
                        cy={334.88}
                        rx={0.88}
                        ry={1.15}
                        transform="translate(-135.23 371.86) rotate(-48.83)"
                      />
                      <ellipse
                        className="clss-30"
                        cx={338.73}
                        cy={334.88}
                        rx={0.88}
                        ry={1.15}
                        transform="translate(-136.34 369.39) rotate(-48.83)"
                      />
                    </g>
                    <line
                      className="clss-31"
                      x1={347.83}
                      y1={345.99}
                      x2={321.4}
                      y2={345.99}
                    />
                    <line
                      className="clss-31"
                      x1={319.52}
                      y1={345.99}
                      x2={293}
                      y2={345.99}
                    />
                    <line
                      className="clss-32"
                      x1={334.17}
                      y1={349.83}
                      x2={327.16}
                      y2={349.83}
                    />
                    <line
                      className="clss-33"
                      x1={348.86}
                      y1={349.83}
                      x2={337.08}
                      y2={349.83}
                    />
                    <line
                      className="clss-32"
                      x1={335.06}
                      y1={353.16}
                      x2={294.93}
                      y2={353.16}
                    />
                    <line
                      className="clss-33"
                      x1={349.76}
                      y1={353.16}
                      x2={337.97}
                      y2={353.16}
                    />
                    <line
                      className="clss-32"
                      x1={335.95}
                      y1={356.48}
                      x2={310.96}
                      y2={356.48}
                    />
                    <line
                      className="clss-33"
                      x1={350.65}
                      y1={356.48}
                      x2={338.86}
                      y2={356.48}
                    />
                    <line
                      className="clss-32"
                      x1={336.85}
                      y1={359.81}
                      x2={307.84}
                      y2={359.81}
                    />
                    <line
                      className="clss-33"
                      x1={351.54}
                      y1={359.81}
                      x2={339.76}
                      y2={359.81}
                    />
                    <line
                      className="clss-34"
                      x1={354.27}
                      y1={369.97}
                      x2={323.86}
                      y2={369.97}
                    />
                    <line
                      className="clss-34"
                      x1={355.44}
                      y1={374.29}
                      x2={325.02}
                      y2={374.29}
                    />
                    <line
                      className="clss-34"
                      x1={356.58}
                      y1={378.56}
                      x2={326.17}
                      y2={378.56}
                    />
                    <line
                      className="clss-33"
                      x1={325.02}
                      y1={349.83}
                      x2={319.43}
                      y2={349.83}
                    />
                    <line
                      className="clss-33"
                      x1={317.55}
                      y1={349.83}
                      x2={311.97}
                      y2={349.83}
                    />
                    <line
                      className="clss-33"
                      x1={310.09}
                      y1={349.83}
                      x2={304.5}
                      y2={349.83}
                    />
                    <line
                      className="clss-31"
                      x1={360.38}
                      y1={392.7}
                      x2={333.95}
                      y2={392.7}
                    />
                    <line
                      className="clss-31"
                      x1={332.07}
                      y1={392.7}
                      x2={305.56}
                      y2={392.7}
                    />
                    <line
                      className="clss-31"
                      x1={347.03}
                      y1={397.67}
                      x2={340.02}
                      y2={397.67}
                    />
                    <line
                      className="clss-31"
                      x1={361.72}
                      y1={397.67}
                      x2={349.94}
                      y2={397.67}
                    />
                    <line
                      className="clss-31"
                      x1={337.88}
                      y1={397.67}
                      x2={332.29}
                      y2={397.67}
                    />
                    <line
                      className="clss-31"
                      x1={330.41}
                      y1={397.67}
                      x2={324.83}
                      y2={397.67}
                    />
                    <line
                      className="clss-31"
                      x1={322.95}
                      y1={397.67}
                      x2={317.36}
                      y2={397.67}
                    />
                  </g>
                  <g id="codeScreenB2">
                    <path
                      className="clss-35"
                      d="M388.83,372.91h80a3.73,3.73,0,0,0,3.75-4.72l-7.71-37.45H375.42l7.71,37.45A6.11,6.11,0,0,0,388.83,372.91Z"
                    />
                    <path
                      className="clss-27"
                      d="M375.42,330.74h89.41l-.86-4.22a6.23,6.23,0,0,0-5.81-4.82H378.38a3.81,3.81,0,0,0-3.83,4.82Z"
                    />
                    <g>
                      <ellipse
                        className="clss-28"
                        cx={458.29}
                        cy={326.63}
                        rx={1.23}
                        ry={1.5}
                        transform="translate(-91.23 448.05) rotate(-47.94)"
                      />
                      <ellipse
                        className="clss-29"
                        cx={453.88}
                        cy={326.63}
                        rx={1.23}
                        ry={1.5}
                        transform="translate(-92.69 444.78) rotate(-47.94)"
                      />
                      <ellipse
                        className="clss-30"
                        cx={449.48}
                        cy={326.63}
                        rx={1.23}
                        ry={1.5}
                        transform="translate(-94.14 441.51) rotate(-47.94)"
                      />
                    </g>
                    <line
                      className="clss-36"
                      x1={460.79}
                      y1={341.59}
                      x2={425.2}
                      y2={341.59}
                    />
                    <line
                      className="clss-36"
                      x1={422.67}
                      y1={341.59}
                      x2={386.96}
                      y2={341.59}
                    />
                    <line
                      className="clss-37"
                      x1={442.07}
                      y1={346.76}
                      x2={432.63}
                      y2={346.76}
                    />
                    <line
                      className="clss-38"
                      x1={461.86}
                      y1={346.76}
                      x2={445.98}
                      y2={346.76}
                    />
                    <line
                      className="clss-37"
                      x1={442.99}
                      y1={351.24}
                      x2={388.95}
                      y2={351.24}
                    />
                    <line
                      className="clss-38"
                      x1={462.78}
                      y1={351.24}
                      x2={446.91}
                      y2={351.24}
                    />
                    <line
                      className="clss-37"
                      x1={443.91}
                      y1={355.71}
                      x2={410.25}
                      y2={355.71}
                    />
                    <line
                      className="clss-38"
                      x1={463.7}
                      y1={355.71}
                      x2={447.83}
                      y2={355.71}
                    />
                    <line
                      className="clss-37"
                      x1={444.83}
                      y1={360.19}
                      x2={405.77}
                      y2={360.19}
                    />
                    <line
                      className="clss-38"
                      x1={464.62}
                      y1={360.19}
                      x2={448.75}
                      y2={360.19}
                    />
                    <line
                      className="clss-38"
                      x1={429.75}
                      y1={346.76}
                      x2={422.23}
                      y2={346.76}
                    />
                    <line
                      className="clss-38"
                      x1={419.7}
                      y1={346.76}
                      x2={412.17}
                      y2={346.76}
                    />
                    <line
                      className="clss-38"
                      x1={409.64}
                      y1={346.76}
                      x2={402.12}
                      y2={346.76}
                    />
                  </g>
                </g>
              </g>
              <g className="clss-24">
                <path
                  className="clss-3"
                  d="M338.65,372.12c-6-3.14-9.88-10.33-9.78-18.21l.46-36.93c0-2.78,2.18-6.42,3.93-8.06l-4.58,1.18c-3.37.91-5.78,4.5-5.83,8.63l-.47,36.93c-.1,7.88,3.75,15.07,9.78,18.22,22.36,11.65,52.67,11.58,75.83,1.17a14.51,14.51,0,0,0,2.44-1.42C387.37,383.7,360.76,383.65,338.65,372.12Z"
                />
              </g>
              <path
                className="clss-39"
                d="M327.69,370.35a20.54,20.54,0,0,1-5.31-14.27c.17-14.08.29-23.3.47-37.38,0-4.26,2.71-7.73,5.83-8.6,21.92-6.11,50.84-8.83,84.33,1.29,3.05.92,5.66,4.94,5.62,8.76C397,318.44,344.73,324.3,327.69,370.35Z"
              />
            </g>
            <g id="eyes">
              <rect
                className="clss-40"
                x={337.51}
                y={330.1}
                width={10.65}
                height={26.2}
                transform="translate(-1.38 1.38) rotate(-0.23)"
              />
              <rect
                className="clss-40"
                x={376.68}
                y={329.18}
                width={11.24}
                height={27.72}
                transform="translate(-1.37 1.54) rotate(-0.23)"
              />
            </g>
          </g>
          <g id="rightAntenna">
            <polygon
              className="clss-16"
              points="492.64 255.41 484.62 243.9 482.33 255.58 492.64 255.41"
            />
            <g>
              <path
                className="clss-41"
                d="M460.79,274.1V217.39a2.39,2.39,0,0,1,2.09-2.38l5.83-.55a7.43,7.43,0,0,1,4.53,1.08c1.91.82,7.63,3.32,7.63,3.32a10.34,10.34,0,0,1,3.43,3.53l7.38,12.53a9.86,9.86,0,0,1,1.36,5.27l-.4,15.21-8.85-4.16s-10.5,34.33-1.84,65.87c10.8,39.36-3.6,52.83-15.65,52-13.43-1-23.47-12.62-22.37-31.21A41.38,41.38,0,0,1,448,322C456.13,305.63,460.28,294.22,460.79,274.1Z"
              />
              <path
                className="clss-18"
                d="M485.34,348.44c-4.28,30.92-35.23,20.59-32.3-11.77,2.06-22.68,17-26.51,16.1-63.43l2-58.59a7.19,7.19,0,0,0-1.07-.19,9.13,9.13,0,0,0-1.19,0l-6,.56a2.4,2.4,0,0,0-2.12,2.41V274.1c-.51,20.12-4.66,31.53-12.81,47.93a41.38,41.38,0,0,0-4.05,15.83c-1.1,18.59,8.94,30.23,22.37,31.21C480.13,369.72,484.74,355.21,485.34,348.44Z"
              />
              <g>
                <g>
                  <polygon
                    className="clss-6"
                    points="470.09 361.68 470.26 317.21 475.74 317.17 475.56 361.64 470.09 361.68"
                  />
                  <path
                    className="clss-6"
                    d="M470.09,361.68c-6.73.14-12.13-9.7-12.08-22s5.53-22.35,12.26-22.49,9.24,9.84,9.19,22.12S476.81,361.54,470.09,361.68Z"
                  />
                  <ellipse
                    className="clss-15"
                    cx={475.65}
                    cy={339.41}
                    rx={22.24}
                    ry={12.17}
                    transform="translate(129.26 810) rotate(-89.15)"
                  />
                </g>
                <g>
                  <polygon
                    className="clss-11"
                    points="477.49 356.93 477.63 321.31 482.02 321.28 481.88 356.9 477.49 356.93"
                  />
                  <path
                    className="clss-11"
                    d="M477.49,356.93c-5.38.12-9.72-7.77-9.68-17.6s4.44-17.91,9.82-18S485,329.19,485,339,482.87,356.82,477.49,356.93Z"
                  />
                  <ellipse
                    className="clss-6"
                    cx={481.95}
                    cy={339.09}
                    rx={17.81}
                    ry={9.75}
                    transform="translate(135.78 815.98) rotate(-89.15)"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
        <g id="rightHandGroup">
          <g id="rightHandThumb">
            <path
              className="clss-5"
              d="M417.48,456.25c-1.06,3.19.13,5.48.77,8.8a8.17,8.17,0,0,1-1,5.39,3.63,3.63,0,1,1-6.62-2.94,3.91,3.91,0,0,1,1.12-1.29c.51-1.08.15-2.38.19-4a16.21,16.21,0,0,1,.41-4c.62-1.94,1.54-5.7,4.23-4.43a2,2,0,0,1,.89,2.43Z"
            />
            <rect
              className="clss-6"
              x={411.17}
              y={454.36}
              width={8.44}
              height={11.43}
              rx={4.22}
              transform="translate(26.83 -22.87) rotate(3.26)"
            />
          </g>
          <g id="rightHandOpenedFingers">
            <g>
              <path
                className="clss-5"
                d="M419.07,456.43a12,12,0,0,0-3.13,7.21,11.25,11.25,0,0,0,.14,2.53,3.54,3.54,0,1,1-7,.14,17.08,17.08,0,0,1,7.66-13.08,2,2,0,0,1,2.36,3.2Z"
              />
              <rect
                className="clss-6"
                x={410.15}
                y={456.23}
                width={6.72}
                height={9.1}
                rx={3.36}
                transform="translate(173.73 -110.02) rotate(19.12)"
              />
            </g>
            <path
              className="clss-5"
              d="M430,464.54A25.19,25.19,0,0,1,433,476a19.87,19.87,0,0,1-.41,4.23,3.54,3.54,0,1,1-7-1.3,18.34,18.34,0,0,0,1.47-6.45,22.1,22.1,0,0,0-.8-6.44,2,2,0,0,1,3.67-1.46Z"
            />
            <rect
              className="clss-6"
              x={426.52}
              y={467}
              width={6.72}
              height={9.1}
              rx={3.36}
              transform="translate(-25.22 24.3) rotate(-3.15)"
            />
            <path
              className="clss-5"
              d="M439.15,460.61c3.13,4.81,4.44,10.42,5,16.05a3.54,3.54,0,1,1-7,0,37.76,37.76,0,0,0,.12-7.21,24.81,24.81,0,0,0-1.58-7.05,2,2,0,0,1,3.49-1.82Z"
            />
            <rect
              className="clss-6"
              x={436.23}
              y={464.58}
              width={6.72}
              height={9.1}
              rx={3.36}
              transform="translate(-100.34 120.13) rotate(-13.98)"
            />
            <path
              className="clss-5"
              d="M445.72,456.48a37.11,37.11,0,0,1,4.74,10.6,3.07,3.07,0,1,1-6.06.64,33.4,33.4,0,0,0-1.8-9.8,1.73,1.73,0,0,1,3.12-1.44Z"
            />
            <rect
              className="clss-6"
              x={443.04}
              y={458.42}
              width={6.72}
              height={9.1}
              rx={3.36}
              transform="translate(-98.65 121.59) rotate(-13.98)"
            />
          </g>
          <path
            id="rightHand"
            className="clss-42"
            d="M411.74,453.75a19.57,19.57,0,0,0,38.45-7.32c-2-10.61-14.07-27.1-24.69-25.08S409.72,443.13,411.74,453.75Z"
          />
          <g id="rightHandClosedFingers">
            <path
              className="clss-5"
              d="M428,464.73c.08,4.32,1.42,9.17,4.77,12.06a3.53,3.53,0,0,1-4.85,5.14,16.44,16.44,0,0,1-2.8-4.67A23.41,23.41,0,0,1,424,464.19a2,2,0,0,1,3.94.54Z"
            />
            <path
              className="clss-5"
              d="M435.29,461.19c.5,1.86,0,4.34.79,5.63a.48.48,0,0,0,.14.06.66.66,0,0,1,.29,0,11.61,11.61,0,0,0,2.44,0,3.55,3.55,0,1,1,.59,7.08c-2.84-.14-6.5-1.17-8.1-3.95s-.22-5.91-.08-8.48a2,2,0,0,1,3.93-.32Z"
            />
            <rect
              className="clss-6"
              x={422.3}
              y={466.6}
              width={8.34}
              height={11.3}
              rx={4.17}
              transform="translate(-80.82 88.13) rotate(-10.78)"
            />
            <path
              className="clss-6"
              d="M435.39,472.71h0a3.69,3.69,0,0,1-4.53-2.58l-.69-2.52a3.69,3.69,0,0,1,2.59-4.52h0c1.63-.45,2.63.45,3.23,1.89a8.48,8.48,0,0,0,1,1.9l.53.73a2.66,2.66,0,0,1,.55,1.74A3.67,3.67,0,0,1,435.39,472.71Z"
            />
            <path
              className="clss-5"
              d="M440.52,456.44c1.29,1.25,2.13,3.43,3.34,4.1a.21.21,0,0,0,.22-.09,11.92,11.92,0,0,0,2.09-1.26,3.3,3.3,0,0,1,3.87,5.35c-2.32,1.25-5.73,2.2-8.34.75s-3-4.59-4.15-6.69a1.86,1.86,0,0,1,3-2.16Z"
            />
            <path
              className="clss-6"
              d="M446.45,465.64h0a3.72,3.72,0,0,1-5.27.14L439.26,464a3.73,3.73,0,0,1-.14-5.27h0c1.18-1.25,2.52-1,3.8-.06a8.86,8.86,0,0,0,1.88,1.11l.84.35a2.76,2.76,0,0,1,1.39,1.22A3.72,3.72,0,0,1,446.45,465.64Z"
            />
          </g>
        </g>
        <g id="codeScreenB">
          <path
            className="clss-43"
            d="M491.18,413h80a3.74,3.74,0,0,0,3.75-4.73l-7.71-37.45H477.78l7.71,37.45A6.09,6.09,0,0,0,491.18,413Z"
          />
          <path
            className="clss-27"
            d="M477.78,370.86h89.41l-.87-4.22a6.21,6.21,0,0,0-5.81-4.81H480.73a3.8,3.8,0,0,0-3.82,4.81Z"
          />
          <g>
            <ellipse
              className="clss-28"
              cx={560.64}
              cy={366.76}
              rx={1.23}
              ry={1.5}
              transform="translate(-87.24 537.29) rotate(-47.94)"
            />
            <ellipse
              className="clss-29"
              cx={556.24}
              cy={366.76}
              rx={1.23}
              ry={1.5}
              transform="translate(-88.69 534.02) rotate(-47.94)"
            />
            <ellipse
              className="clss-30"
              cx={551.83}
              cy={366.76}
              rx={1.23}
              ry={1.5}
              transform="translate(-90.15 530.75) rotate(-47.94)"
            />
          </g>
          <line
            className="clss-36"
            x1={563.15}
            y1={381.71}
            x2={527.56}
            y2={381.71}
          />
          <line
            className="clss-36"
            x1={525.03}
            y1={381.71}
            x2={489.32}
            y2={381.71}
          />
          <line
            className="clss-37"
            x1={544.43}
            y1={386.88}
            x2={534.99}
            y2={386.88}
          />
          <line
            className="clss-38"
            x1={564.21}
            y1={386.88}
            x2={548.34}
            y2={386.88}
          />
          <line
            className="clss-37"
            x1={545.35}
            y1={391.36}
            x2={491.31}
            y2={391.36}
          />
          <line
            className="clss-38"
            x1={565.13}
            y1={391.36}
            x2={549.26}
            y2={391.36}
          />
          <line
            className="clss-37"
            x1={546.27}
            y1={395.84}
            x2={512.61}
            y2={395.84}
          />
          <line
            className="clss-38"
            x1={566.06}
            y1={395.84}
            x2={550.19}
            y2={395.84}
          />
          <line
            className="clss-37"
            x1={547.19}
            y1={400.31}
            x2={508.13}
            y2={400.31}
          />
          <line
            className="clss-38"
            x1={566.98}
            y1={400.31}
            x2={551.11}
            y2={400.31}
          />
          <line
            className="clss-38"
            x1={532.11}
            y1={386.88}
            x2={524.59}
            y2={386.88}
          />
          <line
            className="clss-38"
            x1={522.06}
            y1={386.88}
            x2={514.53}
            y2={386.88}
          />
          <line
            className="clss-38"
            x1={512}
            y1={386.88}
            x2={504.48}
            y2={386.88}
          />
        </g>
        <g id="laptop">
          <g>
            <path
              className="clss-44"
              d="M80.38,385.16a5.38,5.38,0,0,0-5.28,6.36l11.75,50.33a5.37,5.37,0,0,0,5.28,4.38h87a5.13,5.13,0,0,0,2.8-.84,9,9,0,0,1-1.78-3.54l-11.72-50.33a5.28,5.28,0,0,1,2.1-5.31,5.39,5.39,0,0,0-3.12-1Z"
            />
            <path
              className="clss-45"
              d="M179.08,446.23H92.23c.35,2.48,1.54,4.33,4.31,4.33h92.19c-3.46,0-6.33-2.23-6.85-5.17A5.13,5.13,0,0,1,179.08,446.23Z"
            />
            <path
              className="clss-46"
              d="M170.48,386.21a5.28,5.28,0,0,0-2.1,5.31l11.72,50.33a9,9,0,0,0,1.78,3.54,1.2,1.2,0,0,0,.35-.21h0c.14-.11.28-.25.42-.35s.25-.28.35-.39h0a.73.73,0,0,1,.21-.24s.07-.07.07-.11a7,7,0,0,0,.63-1,2,2,0,0,0,.14-.38,3,3,0,0,0,.24-1,1.54,1.54,0,0,0,.07-.42,6.27,6.27,0,0,0,0-1.43l-11.75-50.3a5.57,5.57,0,0,0-.6-1.64,1,1,0,0,1-.1-.18,5.54,5.54,0,0,0-1-1.19,1.71,1.71,0,0,1-.24-.21Z"
            />
            <path
              className="clss-47"
              d="M182.23,445.18a1.2,1.2,0,0,1-.35.21c.52,2.94,3.39,5.17,6.85,5.17H224.9c3.95-.07,3.78-6.12-.17-6.12H183.07a4.78,4.78,0,0,1-.39.39c-.14.1-.28.24-.42.35l0,0Z"
            />
          </g>
          <g>
            <g>
              <path
                className="clss-12"
                d="M122.15,424.05a6.27,6.27,0,0,1-3.28-.79,4.75,4.75,0,0,1-1.93-2.29.31.31,0,0,1,0-.25.26.26,0,0,1,.21-.12l2-.17a.28.28,0,0,1,.25.15,2.58,2.58,0,0,0,1,1.13,2.79,2.79,0,0,0,1.44.35,2,2,0,0,0,1.21-.28.5.5,0,0,0,.19-.55.64.64,0,0,0-.26-.37,2.08,2.08,0,0,0-.74-.32c-.25-.07-.82-.19-1.71-.37a7.9,7.9,0,0,1-2.61-.88,3.26,3.26,0,0,1-1.52-1.86,2,2,0,0,1,.12-1.41,2.16,2.16,0,0,1,1.17-1,5.64,5.64,0,0,1,2-.31,6.06,6.06,0,0,1,3.18.74,3.6,3.6,0,0,1,1.64,2,.24.24,0,0,1,0,.23.27.27,0,0,1-.2.12l-2,.07a.27.27,0,0,1-.24-.15,1.76,1.76,0,0,0-.71-.82,2.48,2.48,0,0,0-1.23-.25,2,2,0,0,0-1.15.25.19.19,0,0,0-.08.24.71.71,0,0,0,.32.36,7.59,7.59,0,0,0,1.94.53,13.83,13.83,0,0,1,2.42.63,4.28,4.28,0,0,1,1.44.92,3.26,3.26,0,0,1,.84,1.47,2.2,2.2,0,0,1-.12,1.56,2.25,2.25,0,0,1-1.25,1.08A6.33,6.33,0,0,1,122.15,424.05Z"
              />
              <path
                className="clss-48"
                d="M119.62,415a5.75,5.75,0,0,1,3,.7,3.36,3.36,0,0,1,1.53,1.87l-2,.08a2,2,0,0,0-.82-.95,2.78,2.78,0,0,0-1.36-.28,2.28,2.28,0,0,0-1.31.3.46.46,0,0,0-.18.53,1,1,0,0,0,.45.52,7.59,7.59,0,0,0,2,.57,13.12,13.12,0,0,1,2.37.61,3.91,3.91,0,0,1,1.35.86,3,3,0,0,1,.77,1.35,1.89,1.89,0,0,1-.1,1.37,1.94,1.94,0,0,1-1.1,1,6.11,6.11,0,0,1-2.11.31A5.93,5.93,0,0,1,119,423a4.39,4.39,0,0,1-1.82-2.17l1.93-.16a2.93,2.93,0,0,0,1.07,1.24,3,3,0,0,0,1.58.39,2.15,2.15,0,0,0,1.39-.35.78.78,0,0,0,.27-.82,1,1,0,0,0-.35-.51,2.4,2.4,0,0,0-.83-.37c-.26-.07-.84-.2-1.74-.37a7.94,7.94,0,0,1-2.52-.84,3,3,0,0,1-1.4-1.71,1.7,1.7,0,0,1,.1-1.22,1.88,1.88,0,0,1,1-.86,5.31,5.31,0,0,1,1.9-.29m0-.54a5.53,5.53,0,0,0-2.1.34,2.34,2.34,0,0,0-1.31,1.12,2.23,2.23,0,0,0-.14,1.59,3.51,3.51,0,0,0,1.63,2,8.3,8.3,0,0,0,2.71.91c.88.18,1.45.3,1.7.37a1.84,1.84,0,0,1,.64.27.44.44,0,0,1,.16.23c0,.09,0,.15-.11.27s-.35.22-1,.22a2.45,2.45,0,0,1-1.3-.31,2.29,2.29,0,0,1-.86-1,.53.53,0,0,0-.49-.3h0l-1.93.16a.52.52,0,0,0-.45.74,5,5,0,0,0,2,2.42,7.7,7.7,0,0,0,5.72.48,2.45,2.45,0,0,0,1.39-1.22A2.42,2.42,0,0,0,126,421a3.48,3.48,0,0,0-.92-1.59,4.52,4.52,0,0,0-1.53-1,8.82,8.82,0,0,0-.87-.29l1.55,0a.55.55,0,0,0,.49-.7,3.93,3.93,0,0,0-1.76-2.17,6.32,6.32,0,0,0-3.32-.78Zm-.59,2.68a1.82,1.82,0,0,1,1-.19,2.35,2.35,0,0,1,1.1.22,1.54,1.54,0,0,1,.6.71l0,.06-.65-.13a6.89,6.89,0,0,1-1.85-.5.61.61,0,0,1-.19-.17Z"
              />
            </g>
            <g>
              <path
                className="clss-12"
                d="M131.64,424a7.37,7.37,0,0,1-2.35-.3,4.49,4.49,0,0,1-1.46-.77,3.52,3.52,0,0,1-.9-1,10.52,10.52,0,0,1-.81-2.22l-.78-2.82h-.81a.27.27,0,0,1-.26-.2l-.18-.65a.28.28,0,0,1,.06-.25l.78-.86a.3.3,0,0,1,.2-.08h2a.27.27,0,0,1,.25.2l1.27,4.6a8.2,8.2,0,0,0,.44,1.37,1.69,1.69,0,0,0,.75.72,2.66,2.66,0,0,0,1.3.29,1.64,1.64,0,0,0,1-.24.55.55,0,0,0,.23-.51,8.45,8.45,0,0,0-.3-1.39l-1.29-4.7a.28.28,0,0,1,0-.23.26.26,0,0,1,.21-.11h2a.28.28,0,0,1,.26.2l1.23,4.46a10.41,10.41,0,0,1,.44,2.23,2,2,0,0,1-.37,1.23,2.45,2.45,0,0,1-1.12.78A5.43,5.43,0,0,1,131.64,424Z"
              />
              <path
                className="clss-48"
                d="M133.16,415.13l1.23,4.46a10.4,10.4,0,0,1,.43,2.17,1.69,1.69,0,0,1-.32,1.06,2.09,2.09,0,0,1-1,.69,5.2,5.2,0,0,1-1.87.26,7.12,7.12,0,0,1-2.26-.28,4.5,4.5,0,0,1-1.38-.73,3.25,3.25,0,0,1-.83-.94,10.36,10.36,0,0,1-.79-2.16l-.84-3h-1l-.18-.65.78-.86h2l1.27,4.6a9.28,9.28,0,0,0,.46,1.42,2.05,2.05,0,0,0,.86.84,2.94,2.94,0,0,0,1.43.32,1.93,1.93,0,0,0,1.22-.3.85.85,0,0,0,.33-.74,8,8,0,0,0-.31-1.44l-1.29-4.7h2m0-.53h-2a.56.56,0,0,0-.43.21.54.54,0,0,0-.09.46l1.29,4.7a7.4,7.4,0,0,1,.29,1.34.31.31,0,0,1-.13.29,1.5,1.5,0,0,1-.88.17,2.43,2.43,0,0,1-1.18-.25,1.45,1.45,0,0,1-.63-.62,8.33,8.33,0,0,1-.42-1.31l-1.27-4.6a.53.53,0,0,0-.52-.39h-2a.52.52,0,0,0-.39.17l-.38.42-.41.44a.54.54,0,0,0-.12.5l.18.65a.56.56,0,0,0,.52.4h.61l.72,2.63a10.58,10.58,0,0,0,.84,2.27,3.74,3.74,0,0,0,1,1.1,5.12,5.12,0,0,0,1.54.82,7.66,7.66,0,0,0,2.44.31,5.75,5.75,0,0,0,2.06-.3,2.61,2.61,0,0,0,1.23-.87,2.17,2.17,0,0,0,.42-1.39,10.3,10.3,0,0,0-.44-2.3L133.68,415a.53.53,0,0,0-.52-.39Z"
              />
            </g>
          </g>
        </g>
        <g id="codeScreenA">
          <path
            className="clss-49"
            d="M97.76,428.54h59.39a2.6,2.6,0,0,0,2.56-3.51l-17.34-64.51H76L93.31,425A4.93,4.93,0,0,0,97.76,428.54Z"
          />
          <path
            className="clss-27"
            d="M76,360.52h66.4l-.84-3.13a5,5,0,0,0-4.54-3.58H77.74a2.65,2.65,0,0,0-2.61,3.58Z"
          />
          <g>
            <ellipse
              className="clss-28"
              cx={137.32}
              cy={357.48}
              rx={0.88}
              ry={1.15}
              transform="translate(-222.17 225.51) rotate(-48.83)"
            />
            <ellipse
              className="clss-29"
              cx={134.05}
              cy={357.48}
              rx={0.88}
              ry={1.15}
              transform="translate(-223.28 223.04) rotate(-48.83)"
            />
            <ellipse
              className="clss-30"
              cx={130.78}
              cy={357.48}
              rx={0.88}
              ry={1.15}
              transform="translate(-224.4 220.58) rotate(-48.83)"
            />
          </g>
          <line
            className="clss-31"
            x1={139.88}
            y1={368.58}
            x2={113.45}
            y2={368.58}
          />
          <line
            className="clss-31"
            x1={111.57}
            y1={368.58}
            x2={85.05}
            y2={368.58}
          />
          <line
            className="clss-32"
            x1={126.22}
            y1={372.42}
            x2={119.21}
            y2={372.42}
          />
          <line
            className="clss-33"
            x1={140.91}
            y1={372.42}
            x2={129.12}
            y2={372.42}
          />
          <line
            className="clss-32"
            x1={127.11}
            y1={375.75}
            x2={86.98}
            y2={375.75}
          />
          <line
            className="clss-33"
            x1={141.8}
            y1={375.75}
            x2={130.02}
            y2={375.75}
          />
          <line
            className="clss-32"
            x1={128}
            y1={379.07}
            x2={103.01}
            y2={379.07}
          />
          <line
            className="clss-33"
            x1={142.7}
            y1={379.07}
            x2={130.91}
            y2={379.07}
          />
          <line
            className="clss-32"
            x1={128.9}
            y1={382.4}
            x2={99.89}
            y2={382.4}
          />
          <line
            className="clss-33"
            x1={143.59}
            y1={382.4}
            x2={131.81}
            y2={382.4}
          />
          <line
            className="clss-34"
            x1={146.32}
            y1={392.56}
            x2={115.91}
            y2={392.56}
          />
          <line
            className="clss-34"
            x1={147.49}
            y1={396.88}
            x2={117.07}
            y2={396.88}
          />
          <line
            className="clss-34"
            x1={148.63}
            y1={401.15}
            x2={118.22}
            y2={401.15}
          />
          <line
            className="clss-33"
            x1={117.07}
            y1={372.42}
            x2={111.48}
            y2={372.42}
          />
          <line
            className="clss-33"
            x1={109.6}
            y1={372.42}
            x2={104.02}
            y2={372.42}
          />
          <line
            className="clss-33"
            x1={102.14}
            y1={372.42}
            x2={96.55}
            y2={372.42}
          />
          <line
            className="clss-31"
            x1={152.43}
            y1={415.29}
            x2={126}
            y2={415.29}
          />
          <line
            className="clss-31"
            x1={124.12}
            y1={415.29}
            x2={97.61}
            y2={415.29}
          />
          <line
            className="clss-31"
            x1={139.08}
            y1={420.26}
            x2={132.07}
            y2={420.26}
          />
          <line
            className="clss-31"
            x1={153.77}
            y1={420.26}
            x2={141.98}
            y2={420.26}
          />
          <line
            className="clss-31"
            x1={129.93}
            y1={420.26}
            x2={124.34}
            y2={420.26}
          />
          <line
            className="clss-31"
            x1={122.46}
            y1={420.26}
            x2={116.88}
            y2={420.26}
          />
          <line
            className="clss-31"
            x1={115}
            y1={420.26}
            x2={109.41}
            y2={420.26}
          />
        </g>
        <g id="desktop">
          <rect
            className="clss-5"
            x={356.55}
            y={450.51}
            width={218.45}
            height={6.35}
          />
          <g className="clss-24">
            <rect
              className="clss-3"
              x={533.3}
              y={450.51}
              width={41.7}
              height={6.35}
            />
          </g>
        </g>
        <g id="axis">
          <circle
            id="shadowAxis"
            className="clss-50"
            cx={394.58}
            cy={491.04}
            r={1.56}
          />
          <circle
            id="rightHandAxis"
            className="clss-50"
            cx={425.59}
            cy={421.74}
            r={1.56}
          />
          <circle
            id="leftHandAxis"
            className="clss-50"
            cx={358.74}
            cy={423.82}
            r={1.56}
          />
          <circle
            id="bodyAxis"
            className="clss-50"
            cx={394.1}
            cy={400.31}
            r={1.56}
          />
          <circle
            id="headAxis"
            className="clss-50"
            cx={392.45}
            cy={395.56}
            r={1.56}
          />
          <circle
            id="eyesAxis"
            className="clss-50"
            cx={362.37}
            cy={343.68}
            r={1.56}
          />
          <circle
            id="faceAxis"
            className="clss-50"
            cx={323.96}
            cy={341.48}
            r={1.56}
          />
          <circle
            id="leftAntennaAxis"
            className="clss-50"
            cx={340.7}
            cy={348.87}
            r={1.56}
          />
          <circle
            id="rightAntennaAxis"
            className="clss-50"
            cx={468.73}
            cy={362.86}
            r={1.56}
          />
        </g>
      </g>
    </g>
  </svg>
  </DrawSVG>
);

export default UnoBot;
